// Arabic translations
export const ar: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'لوحة التحكم',
  'menu.orderNew': 'تسجيل المنتج',
  'menu.deliveryList': 'قائمة التسليم',
  'menu.delivery': 'التسليم',
  'menu.receipt': 'طباعة الإيصال/الملصق',
  'menu.definitions': 'التعريفات',
  'menu.customers': 'العملاء',
  'menu.products': 'تعريفات المنتجات',
  'menu.pricing': 'تعريفات الأسعار',
  'menu.tailoring': 'عمليات الخياطة',
  'menu.attributes': 'سمات المنتجات',
  'menu.users': 'المستخدمون',
  'menu.productOrdering': 'ترتيب المنتجات',
  'menu.discounts': 'تعريفات الخصومات',
  'menu.settings': 'الإعدادات',
  'menu.generalSettings': 'الإعدادات العامة',
  'menu.permissions': 'إدارة الصلاحيات',
  'menu.subscription': 'الاشتراك',
  'menu.invoices': 'إدارة الفواتير',
  'menu.expenses': 'إدخال المصروفات',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'التقارير والمحاسبة',
  'menu.systemAndCommunication': 'النظام والتواصل',
  'menu.reportsList': 'قائمة الإيصالات',
  'menu.accountStatement': 'كشف الحساب',
  'reportsList.totalReceipts': 'إجمالي الإيصالات',
  'reportsList.registered': 'مسجلة',
  'reportsList.delivered': 'تم التسليم',
  'reportsList.totalRevenueExclCancelled': 'إجمالي الإيرادات (بدون الملغاة)',
  'reportsList.activeOnly': 'الطلبات النشطة فقط',
  'reportsList.receiptNumber': 'رقم الإيصال',
  'reportsList.customer': 'العميل',
  'reportsList.phone': 'الهاتف',
  'reportsList.date': 'التاريخ',
  'reportsList.amount': 'المبلغ',
  'reportsList.status': 'الحالة',
  'reportsList.payment': 'الدفع',
  'reportsList.searchPlaceholder': 'رقم الإيصال، اسم العميل أو الهاتف...',
  'reportsList.noOrders': 'لم يتم العثور على طلبات',
  'reportsList.cancelled': 'ملغى',
  'reportsList.reprint': 'إعادة الطباعة',
  'menu.tickets': 'طلبات الدعم',
  'menu.support': 'الدعم',
  'menu.profile': 'الملف الشخصي',
  'menu.logout': 'تسجيل الخروج',
  'menu.notifications': 'إشعارات الرسائل القصيرة/واتساب',
  'menu.whatsappConnection': 'اتصال واتساب',
  'menu.smsConnection': 'اتصال الرسائل القصيرة',
  
  // Dashboard
  'dashboard.title': 'لوحة التحكم',
  'dashboard.todaySales': 'مبيعات اليوم',
  'dashboard.totalOrders': 'إجمالي الطلبات',
  'dashboard.pendingDeliveries': 'التسليمات المعلقة',
  'dashboard.activeCustomers': 'العملاء النشطون',
  'dashboard.recentOrders': 'الطلبات الأخيرة',
  'dashboard.viewAll': 'عرض الكل',
  'dashboard.quickActions': 'الإجراءات السريعة',
  'dashboard.newOrder': 'طلب جديد',
  'dashboard.newCustomer': 'عميل جديد',
  'dashboard.deliveries': 'التسليمات',
  'dashboard.reports': 'التقارير',
  'dashboard.today': 'اليوم',
  'dashboard.yesterday': 'أمس',
  'dashboard.week': 'أسبوع',
  'dashboard.month': 'شهر',
  'dashboard.quarter': 'ربع سنة',
  'dashboard.year': 'سنة',
  'dashboard.totalRevenue': 'إجمالي الإيرادات',
  'dashboard.totalOrdersCard': 'إجمالي الطلبات',
  'dashboard.totalPieces': 'إجمالي القطع',
  'dashboard.cancelled': 'ملغى',
  'dashboard.inProcess': 'قيد التنفيذ',
  'dashboard.inProcessDesc': 'الطلبات قيد التنفيذ',
  'dashboard.ready': 'جاهز',
  'dashboard.readyDesc': 'الطلبات الجاهزة للتسليم',
  'dashboard.delivered': 'تم التسليم',
  'dashboard.deliveredDesc': 'الطلبات المكتملة',
  'dashboard.announcements': 'الإعلانات',
  'dashboard.announcementAll': 'عام',
  'dashboard.announcementPrivate': 'خاص',
  
  // Order Entry
  'order.title': 'طلب جديد',
  'order.customer': 'العميل',
  'order.selectCustomer': 'اختر العميل',
  'order.newCustomer': 'عميل جديد',
  'order.products': 'المنتجات',
  'order.addProduct': 'إضافة منتج',
  'order.selectProduct': 'اختر المنتج',
  'order.quantity': 'الكمية',
  'order.price': 'السعر',
  'order.total': 'الإجمالي',
  'order.discount': 'الخصم',
  'order.subtotal': 'المجموع الفرعي',
  'order.tax': 'ضريبة القيمة المضافة',
  'order.grandTotal': 'الإجمالي الكلي',
  'order.payment': 'الدفع',
  'order.paymentMethod': 'طريقة الدفع',
  'order.cash': 'نقداً',
  'order.card': 'بطاقة ائتمان',
  'order.credit': 'على الحساب',
  'order.amountPaid': 'المبلغ المدفوع',
  'order.remainingBalance': 'الرصيد المتبقي',
  'order.deliveryDate': 'تاريخ التسليم',
  'order.notes': 'ملاحظات',
  'order.createOrder': 'إنشاء طلب',
  'order.cancel': 'إلغاء',
  
  // Users
  'users.title': 'المستخدمون',
  'users.addNew': 'مستخدم جديد',
  'users.name': 'الاسم',
  'users.email': 'البريد الإلكتروني',
  'users.role': 'الدور',
  'users.pin': 'رمز PIN',
  'users.permissions': 'الصلاحيات',
  'users.allPermissions': 'جميع الصلاحيات',
  'users.permissionCount': '{count} صلاحيات',
  'users.changePin': 'تغيير رمز PIN',
  'users.edit': 'تعديل',
  'users.delete': 'حذف',
  'users.newUser': 'مستخدم جديد',
  'users.editUser': 'تعديل المستخدم',
  'users.editingUser': 'تعديل {name}',
  'users.deleteUserTitle': 'حذف المستخدم',
  'users.deletingUser': 'هل أنت متأكد من حذف {name}؟',
  'users.pinCode': 'رمز PIN (4-6 أرقام)',
  'users.selectRole': 'اختر الدور',
  'users.patron': 'المالك',
  'users.kasiyer': 'أمين الصندوق',
  'users.sofor': 'السائق',
  'users.eleman': 'موظف',
  'users.changePinTitle': 'تغيير رمز PIN',
  'users.newPin': 'رمز PIN جديد',
  'users.confirmPin': 'تأكيد رمز PIN',
  'users.pinMismatch': 'رموز PIN غير متطابقة',
  'users.pinRequired': 'رمز PIN مطلوب',
  'users.pinLength': 'يجب أن يحتوي رمز PIN على 4-6 أرقام',
  'users.changingPinFor': 'تغيير PIN لـ {name}',
  
  // Products
  'products.title': 'تعريفات المنتجات',
  'products.addNew': 'منتج جديد',
  'products.category': 'الفئة',
  'products.name': 'اسم المنتج',
  'products.price': 'السعر',
  'products.color': 'اللون',
  'products.active': 'نشط',
  'products.actions': 'الإجراءات',
  'products.search': 'بحث عن منتج...',
  'products.noProducts': 'لم يتم العثور على منتجات',
  'products.noCategoryProducts': 'لا توجد منتجات في هذه الفئة',
  'products.emptyCart': 'السلة فارغة',
  
  // Service Types
  'service.tailor': 'خياطة',
  'service.dryCleaning': 'التنظيف الجاف',
  'service.washing': 'الغسيل',
  'service.ironing': 'الكي',
  'service.dyeing': 'صباغة',
  'service.shoeShine': 'تلميع الأحذية',
  'service.carpet': 'سجاد',
  'service.tailoring': 'تعديلات الخياطة',
  'service.carpetWashing': 'غسيل السجاد',
  'service.sofaWashing': 'غسيل الأرائك',
  'service.carWash': 'غسيل السيارات والتلميع',
  'service.barber': 'حلاق / مصفف شعر',
  'service.selectService': 'اختر الخدمة',
  'service.addToCart': 'إضافة إلى السلة',
  'service.total': 'الإجمالي',
  
  // Common
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.cancel': 'إلغاء',
  'common.confirm': 'تأكيد',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.save': 'حفظ',
  'common.search': 'بحث',
  'common.loading': 'جاري التحميل...',
  'common.noData': 'لا توجد بيانات',
  'common.actions': 'الإجراءات',
  'common.status': 'الحالة',
  'common.date': 'التاريخ',
  'common.time': 'الوقت',
  'common.total': 'الإجمالي',
  'common.filter': 'تصفية',
  'common.export': 'تصدير',
  'common.print': 'طباعة',
  'common.close': 'إغلاق',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.previous': 'السابق',
  'common.submit': 'إرسال',
  'common.reset': 'إعادة تعيين',
  'common.create': 'إنشاء',
  'common.creating': 'جاري الإنشاء...',
  'common.later': 'لاحقاً',
  'common.clear': 'مسح',
  'common.copied': 'تم النسخ!',
  'common.copyError': 'فشل النسخ',
  'common.perPage': 'لكل صفحة',
  'common.page': 'صفحة',
  'common.orders': 'طلبات',
  'common.pieces': 'قطع',
  
  // Login
  'login.title': 'كلين دي',
  'login.subtitle': 'نظام إدارة التنظيف الجاف',
  'login.tenantId': 'معرف الشركة',
  'login.tenantPlaceholder': 'معرف-الشركة (مثال: acme-clean)',
  'login.tenantIdHelp': 'أدخل معرف شركتك الفريد',
  'login.continue': 'متابعة ←',
  'login.notMember': 'لست عضواً بعد؟',
  'login.startTrial': 'ابدأ الفترة التجريبية المجانية',
  'login.adminLogin': '🔒 تسجيل دخول المدير',
  'login.enterPin': 'أدخل رمز PIN الخاص بك',
  'login.changeTenant': 'تغيير الشركة',
  'login.clear': 'مسح',
  'login.delete': 'حذف',
  'login.login': 'تسجيل الدخول',
  'login.loggingIn': 'جاري تسجيل الدخول...',
  'login.defaultPinOwner': 'رمز PIN الافتراضي: <strong>1234</strong> (المالك)',
  'login.defaultPinCashier': 'رمز PIN الافتراضي: <strong>0000</strong> (أمين الصندوق)',
  'login.systemInitializing': 'جاري تهيئة النظام...',
  'login.pinMinLength': 'يجب أن يحتوي رمز PIN على 4 أرقام على الأقل',
  'login.invalidTenantId': 'أدخل معرف شركة صالح',
  'login.tenantNotFound': 'لم يتم العثور على رمز الشركة هذا. تحقق أو أنشئ حساباً جديداً.',
  'login.loginFailed': 'فشل تسجيل الدخول',
  'login.welcome': 'مرحباً، {name}',

  // Signup translations
  'signup.title': 'ابدأ الفترة التجريبية المجانية',
  'signup.subtitle': '15 يوماً مجانياً، لا حاجة لبطاقة ائتمان',
  'signup.backToLogin': 'العودة إلى صفحة تسجيل الدخول',
  'signup.companyCode': 'رمز الشركة',
  'signup.companyCodePlaceholder': 'مثال: cleanpro',
  'signup.companyCodeHelp': 'سيتم استخدام هذا الرمز لتسجيل الدخول إلى النظام',
  'signup.companyCodeMinLength': 'يجب أن يحتوي رمز الشركة على 3 أحرف على الأقل',
  'signup.companyName': 'اسم الشركة',
  'signup.companyNamePlaceholder': 'اسم شركتك',
  'signup.companyNameRequired': 'اسم الشركة مطلوب',
  'signup.fullName': 'الاسم الكامل',
  'signup.fullNamePlaceholder': 'اسمك الكامل',
  'signup.fullNameRequired': 'الاسم الكامل مطلوب',
  'signup.phone': 'الهاتف',
  'signup.phonePlaceholder': '+966 50 123 4567',
  'signup.validPhoneRequired': 'أدخل رقم هاتف صالح',
  'signup.email': 'البريد الإلكتروني',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'أدخل عنوان بريد إلكتروني صالح',
  'signup.createAccount': 'إنشاء حساب',
  'signup.creating': 'جاري الإنشاء...',
  'signup.terms': 'بإنشاء حساب، فإنك توافق على شروط الخدمة وسياسة الخصوصية.',
  'signup.success': 'تم التسجيل بنجاح! تم إرسال معلومات تسجيل الدخول إلى بريدك الإلكتروني.',
  'signup.successTitle': 'تم التسجيل بنجاح!',
  'signup.successMessage': 'تم إنشاء حسابك بنجاح.',
  'signup.emailSent': 'تم إرسال معلومات تسجيل الدخول إلى بريدك الإلكتروني.',
  'signup.redirecting': 'جاري التحويل إلى صفحة تسجيل الدخول...',
  'signup.startupPackageLoaded': 'تم تحميل حزمة البداية!',
  'signup.products': 'المنتجات',
  'signup.customers': 'العملاء',
  'signup.users': 'المستخدمون',
  'signup.demoDataReady': '✨ بياناتك التجريبية جاهزة، يمكنك البدء في استخدامها على الفور!',
  'signup.loginInfo': '📧 معلومات تسجيل الدخول الخاصة بك',
  'signup.loginInfoSent': '💡 تم إرسال هذه المعلومات أيضاً إلى بريدك الإلكتروني',
'signup.loginNow': 'تسجيل الدخول الآن ←',
  'signup.hints.companyCode': 'يُستخدم لتسجيل الدخول',
  'signup.hints.country': 'تم اكتشاف بلدك تلقائياً. يمكنك اختيار بلد مختلف.',
  'signup.freeTrial': '🎉 جرب مجاناً لمدة 15 يوماً - لا حاجة لبطاقة ائتمان!',
  'signup.businessType.question': 'ما نوع عملك؟',
  'signup.businessType.hint': 'سيتم ضبط شاشتك الافتراضية تلقائياً حسب اختيارك',
  'signup.businessType.continue': 'متابعة',
  'signup.bt.dryCleaning.desc': 'تنظيف الملابس والستائر والمنسوجات',
  'signup.bt.carpetWashing.desc': 'غسيل السجاد والكليم والممرات',
  'signup.bt.shoeShine.desc': 'تنظيف الأحذية والعناية بها',
  'signup.bt.sofaWashing.desc': 'غسيل الأرائك والكنبات والمقاعد',
  'signup.bt.carWash.desc': 'غسيل السيارات والتلميع والعناية بها',
  'signup.bt.tailoring.desc': 'خياطة وتعديل وخدمات الخياطة',
  'signup.bt.barber.desc': 'صالون حلاقة وتصفيف الشعر والتجميل',
  'signup.bt.tailoring.desc': 'خياطة وتعديل وتفصيل الملابس',
  'signup.bt.barber.desc': 'صالون حلاقة وتجميل وعناية بالشعر',

  // Subscription Page
  'subscription.title': 'خطط الاشتراك',
  'subscription.currentPlan': 'خطتك الحالية',
  'subscription.upgradePlan': 'ترقية',
  'subscription.downgradePlan': 'خفض الدرجة',
  'subscription.choosePlan': 'اختر خطة',
  'subscription.billingCycle': 'دورة الفوترة',
  'subscription.monthly': 'شهري',
  'subscription.yearly': 'سنوي',
  'subscription.perMonth': '/شهر',
  'subscription.perYear': '/سنة',
  'subscription.plusVAT': '+ ضريبة القيمة المضافة',
  'subscription.save': 'وفر {percent}%',
  'subscription.mostPopular': 'الأكثر شعبية',
  'subscription.freeTrial': '{months} شهر مجاني',
  'subscription.featuresIncluded': 'الميزات المتضمنة:',
  'subscription.starter': 'ستارتر',
  'subscription.starterDesc': 'مثالي للأعمال الصغيرة',
  'subscription.professional': 'محترف',
  'subscription.professionalDesc': 'للشركات النامية',
  'subscription.enterprise': 'مؤسسة',
  'subscription.enterpriseDesc': 'حلول المؤسسات',
  'subscription.maxReceipts': 'حد أقصى {count} إيصال/شهر',
  'subscription.maxUsers': '{count} حسابات مستخدمين',
  'subscription.whatsappCredits': '🎁 {count} رصيد واتساب هدية',
  'subscription.basicReports': 'تقارير أساسية',
  'subscription.advancedReports': 'تقارير متقدمة',
  'subscription.customReports': 'تقارير مخصصة',
  'subscription.whatsappIntegration': 'تكامل واتساب',
  'subscription.supportTicket': 'وقت الرد على التذكرة: {hours} ساعة',
  'subscription.supportTicketBusiness': 'وقت الرد على التذكرة: {hours} ساعة (أوقات العمل)',
  'subscription.accountManagement': 'إدارة الحساب',
  'subscription.driverApp': 'تطبيق الهاتف المحمول للسائق',
  'subscription.prioritySupport': 'دعم ذو أولوية',
  'subscription.managerApp': 'تطبيق الهاتف المحمول - عرض المدير',
  'subscription.paymentTitle': 'إتمام الدفع',
  'subscription.planSelection': 'الخطة المحددة',
  'subscription.billingPeriod': 'فترة الفوترة',
  'subscription.month': 'شهر',
  'subscription.year': 'سنة',
  'subscription.subtotal': 'المجموع الفرعي',
  'subscription.tax': 'ضريبة القيمة المضافة ({rate}%)',
  'subscription.total': 'المجموع',
  'subscription.couponCode': 'رمز القسيمة',
  'subscription.applyCoupon': 'تطبيق',
  'subscription.remove Coupon': 'إزالة',
  'subscription.discount': 'خصم',
  'subscription.invalidCoupon': 'رمز قسيمة غير صالح',
  'subscription.couponVerificationFailed': 'فشل التحقق من القسيمة',
  'subscription.couponRemoved': 'تمت إزالة القسيمة',
  'subscription.billingInfo': 'معلومات الفوترة',
  'subscription.companyName': 'اسم الشركة',
  'subscription.companyNamePlaceholder': 'أدخل اسم الشركة',
  'subscription.taxNumber': 'الرقم الضريبي',
  'subscription.taxNumberPlaceholder': 'أدخل الرقم الضريبي',
  'subscription.phone': 'الهاتف',
  'subscription.phonePlaceholder': 'أدخل رقم الهاتف',
  'subscription.address': 'العنوان',
  'subscription.addressPlaceholder': 'أدخل عنوان الفوترة',
  'subscription.corporateInvoice': 'فاتورة الشركة',
  'subscription.individualInvoice': 'فاتورة فردية',
  'subscription.paymentMethod': 'طريقة الدفع',
  'subscription.creditCard': 'بطاقة ائتمان',
  'subscription.bankTransfer': 'تحويل بنكي',
  'subscription.cardNumber': 'رقم البطاقة',
  'subscription.cardNumberPlaceholder': 'أدخل رقم البطاقة',
  'subscription.expiryDate': 'تاريخ الانتهاء',
  'subscription.cvc': 'CVC',
  'subscription.completePayment': 'إتمام الدفع',
  'subscription.processing': 'جاري المعالجة...',
  'subscription.redirectingToPayment': 'إعادة التوجيه إلى صفحة الدفع...',
  'subscription.paymentSuccess': '✅ الدفع ناجح! تم تفعيل اشتراكك.',
  'subscription.paymentCompleted': '🎉 تم إتمام الدفع بنجاح!',
  'subscription.paymentCancelled': '❌ تم إلغاء الدفع.',
  'subscription.paddleTestCards': 'تم طباعة بطاقات اختبار Paddle في وحدة التحكم! (F12)',
  'subscription.sandboxTestCards': '🎴 بطاقات الاختبار (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ بطاقات الاختبار الناجحة:',
  'subscription.failedPaymentCards': '❌ بطاقات الاختبار الفاشلة:',
  'subscription.invalidCard': '📌 بطاقة غير صالحة:',
  'subscription.sandboxOnly': '📝 ملاحظة: هذه البطاقات تعمل فقط في بيئة Sandbox!',
  'subscription.enterCompanyName': 'أدخل اسم الشركة',
  'subscription.enterPhone': 'أدخل رقم الهاتف',
  'subscription.enterTaxNumber': 'أدخل الرقم الضريبي',
  'subscription.selectPackage': 'يرجى تحديد باقة',
  'subscription.selectPlan': 'يرجى تحديد خطة',
  'subscription.paddleNotLoaded': 'لم يتم تحميل Paddle SDK بعد. يرجى إعادة تحميل الصفحة.',
  'subscription.paymentError': 'خطأ في الدفع: ',
  'subscription.paymentCreationFailed': 'فشل إنشاء الدفع. يرجى التحقق من سجلات وحدة التحكم.',
  'subscription.paddleConfigurationMissing': '⚠️ تكوين Paddle مفقود!',
  'subscription.paddleDashboardRequired': '⚠️ مطلوب تكوين لوحة تحكم Paddle!',
  'subscription.paddleApiNotConfigured': 'مفتاح API الخاص بـ Paddle غير مكوّن. يرجى الاتصال بالمسؤول.',
  'subscription.cancelConfirm': 'هل أنت متأكد من إلغاء اشتراكك؟ ستستمر خدمتك حتى نهاية فترة الفوترة.',
  'subscription.cancelSuccess': '✅ تم إلغاء الاشتراك. ستستمر خدمتك حتى نهاية فترة الفوترة.',
  'subscription.cancelFailed': 'فشل الإلغاء',
  'subscription.region.turkey': '🇹🇷 تركيا',
  'subscription.region.europe': '🇪🇺 أوروبا',
  'subscription.region.other': '🌎 أخرى',
  'subscription.status': 'الحالة',
  'subscription.active': 'نشط',
  'subscription.sandboxMode': '🧪 SANDBOX (وضع الاختبار)',
  'subscription.liveMode': '🚀 مباشر (الإنتاج)',
  'subscription.paddleActive': 'نشط',
  'subscription.paddleConfigured': '✅ نعم',
  'subscription.paddleNotConfigured': '❌ لا',
  'subscription.whatsappCreditsTitle': 'رصيد واتساب',
  'subscription.whatsappCreditsPackages': 'باقات الرصيد',
  'subscription.whatsappCurrentBalance': 'الرصيد الحالي',
  'subscription.whatsappCreditsAmount': '{count} رصيد',
  'subscription.whatsappPurchaseCredits': 'شراء رصيد',
  'toast.productsLoadError': 'فشل تحميل المنتجات',
  'toast.statsLoadError': 'فشل تحميل الإحصائيات',
  'toast.orderDetailsLoadError': 'فشل تحميل تفاصيل الطلب',
  'toast.orderLoadError': 'فشل تحميل الطلب',
  'toast.deliveryBeforeToday': 'لا يمكن أن يكون تاريخ التسليم قبل اليوم',
  'toast.customerOpenOrders': 'العميل لديه {count} طلبات مفتوحة',
  'toast.customerDebt': 'العميل لديه دين بقيمة {amount}',
  'toast.customerSaved': 'تم حفظ العميل',
  'toast.customerSaveError': 'فشل حفظ العميل',
  'toast.customerUpdated': 'تم تحديث العميل',
  'toast.customerUpdateError': 'فشل تحديث العميل',
  'toast.customerExistingSelected': 'تم اختيار عميل موجود',
  'toast.productAddedToCart': 'تم إضافة المنتج إلى السلة',
  'toast.productAdded': 'تم إضافة المنتج',
  'toast.productDetailsUpdated': 'تم تحديث تفاصيل المنتج',
  'toast.priceUpdated': 'تم تحديث السعر',
  'toast.selectAtLeastOneService': 'يرجى اختيار خدمة واحدة على الأقل',
  'toast.selectCustomer': 'يرجى اختيار عميل',
  'toast.addProduct': 'يرجى إضافة منتج',
  'toast.addressRequiredForDelivery': 'عنوان العميل مطلوب للتوصيل للمنزل',
  'toast.orderSaved': 'تم حفظ الطلب',
  'toast.orderSaveError': 'فشل حفظ الطلب',
  'toast.cardPaymentSuccess': 'نجحت عملية الدفع بالبطاقة!',
  'toast.cardPaymentError': 'فشلت عملية الدفع بالبطاقة',
  'toast.paymentFailedTryAgain': 'فشلت عملية الدفع. يرجى المحاولة مرة أخرى.',
  'toast.paymentStatusCheckFailed': 'تعذر التحقق من حالة الدفع.',
  'toast.customerPhoneNotFound': 'لم يتم العثور على رقم هاتف العميل',
  'toast.whatsappSent': 'تم إرسال رسالة WhatsApp! ✅',
  'toast.whatsappFailed': 'فشل إرسال رسالة WhatsApp',
  'toast.orderUpdateError': 'فشل تحديث الطلب',
  'toast.searchError': 'خطأ في البحث',
  'toast.orderNotFound': 'الطلب غير موجود',
  'toast.editCancelled': 'تم إلغاء التحرير',
  'toast.noEditPermission': 'ليس لديك إذن لتحرير الطلبات السابقة',
  'toast.selectAtLeastOneOperation': 'يرجى اختيار عملية واحدة على الأقل',
  'toast.tailorAddedToCart': 'تم إضافة عملية الخياطة إلى السلة',
  'toast.enterValidArea': 'يرجى إدخال مساحة صالحة',
  'toast.enterValidAmount': 'يرجى إدخال مبلغ صالح',
  'toast.amountExceedsRemaining': 'المبلغ لا يمكن أن يتجاوز الرصيد المتبقي',
  'toast.fillAllCardInfo': 'يرجى ملء جميع معلومات البطاقة',
  'toast.invalidCardNumber': 'رقم بطاقة غير صالح',
  'toast.invalidMonth': 'شهر غير صالح (يجب أن يكون 1-12)',
  'toast.invalidYear': 'سنة غير صالحة',
  'toast.invalidCvc': 'رمز CVC غير صالح',

  // Settings
  'settings.title': 'الإعدادات',
  'settings.save': 'حفظ',
  'settings.loading': 'جاري التحميل...',
  'settings.general': 'الإعدادات العامة',
  'settings.languageRegion': 'اللغة والمنطقة',
  'settings.language': 'اللغة',
  'settings.currency': 'العملة',
  'settings.currencyPosition': 'موضع العملة',
  'settings.currencyPositionLeft': 'يسار (١٠٠$)',
  'settings.currencyPositionRight': 'يمين ($١٠٠)',
  'settings.numberFormat': 'تنسيق الأرقام',
  'settings.numberFormatDotComma': 'نقطة للكسور العشرية (1.234,56)',
  'settings.numberFormatCommaDot': 'فاصلة للكسور العشرية (1,234.56)',
  'settings.numberFormatSpaceComma': 'مسافة للكسور العشرية (1 234,56)',
  'settings.showDecimals': 'إظهار المنازل العشرية',
  'settings.showDecimalsDesc': 'إظهار منزلتين عشريتين للمبالغ',
  'settings.dateFormat': 'تنسيق التاريخ',
  'settings.timezone': 'المنطقة الزمنية',
  'settings.taxRate': 'معدل الضريبة',
  'settings.receiptSettings': 'إعدادات الإيصال',
  'settings.logo': 'الشعار',
  'settings.removeLogo': 'إزالة الشعار',
  'settings.uploadLogo': 'رفع الشعار',
  'settings.companyName': 'اسم الشركة',
  'settings.companyNamePlaceholder': 'أدخل اسم الشركة',
  'settings.phone': 'الهاتف',
  'settings.address': 'العنوان',
  'settings.addressPlaceholder': 'أدخل العنوان',
  'settings.footerText': 'نص التذييل',
  'settings.footerTextPlaceholder': 'أدخل نص التذييل',
  'settings.receiptNote': 'ملاحظة الإيصال',
  'settings.receiptNotePlaceholder': 'أدخل ملاحظة الإيصال',
  'settings.socialMedia': 'وسائل التواصل',
  'settings.website': 'الموقع',
  'settings.dangerZone': 'منطقة الخطر',
  'settings.deleteDemoData': 'حذف بيانات العرض',
  'settings.deleteDemoDataTitle': 'حذف بيانات العرض',
  'settings.deleteDemoDataConfirm': 'لا يمكن التراجع عن هذا الإجراء! سيتم حذف العملاء التجريبيين وإيصالاتهم ومدفوعاتهم؛ وسيتم الاحتفاظ بعملائك وإيصالاتك.',
  'toast.noDemoData': 'لا يوجد عملاء تجريبيون لحذفهم.',
  'toast.demoCustomersKept': 'تم الاحتفاظ بـ {n} من العملاء التجريبيين لأن لديهم إيصالات أنشأتها؛ تم حذف إيصالاتهم التجريبية فقط.',
  'toast.demoDataDeleted': 'تم حذف البيانات التجريبية',
  'settings.deleteDemoDataWarning': 'يحذف العملاء التجريبيين المضافين تلقائيًا عند الإعداد مع إيصالاتهم ومدفوعاتهم. لا يتم حذف العملاء والإيصالات التي أضفتها بنفسك.',
  'settings.productsWillBeKept': 'سيتم الاحتفاظ بالمنتجات',
  'settings.areYouSure': 'هل أنت متأكد؟',
  'settings.deleting': 'جاري الحذف...',
  'settings.loadSchema': 'تحميل المخطط',
  'settings.loadSchemaTitle': 'تحميل مخطط قاعدة البيانات',
  'settings.loadSchemaConfirm': 'سيؤدي ذلك إلى إنشاء مخطط قاعدة البيانات. هل تريد المتابعة؟',
  'settings.connected': 'متصل',
  'settings.notConnected': 'غير متصل',
  'settings.connect': 'اتصال',
  'settings.disconnect': 'قطع الاتصال',
  'settings.showTax': 'إظهار الضريبة',
  'settings.headerInfo': 'معلومات الرأس',
  'settings.headerInfoPlaceholder': 'مثال: التنظيف الجاف والكي',
  'settings.footerTextHelp': 'رسالة قصيرة تظهر أسفل الإيصال',
  'settings.receiptNoteHelp': 'الشروط والأحكام التفصيلية',
  'settings.receiptPreview': 'معاينة الإيصال',
  'settings.expenses': 'المصروفات',
  'settings.invoices': 'الفواتير',
  'settings.reports': 'التقارير',
  'settings.tickets': 'طلبات الدعم',
  'settings.zReport': 'تقرير Z',

  // Receipt Page
  'receipt.title': 'إيصال',
  'receipt.receiptNumber': 'رقم الإيصال',
  'receipt.date': 'التاريخ',
  'receipt.subtotal': 'المجموع الفرعي',
  'receipt.payment': 'الدفع',
   'receipt.thankYou': 'شكراً!',
   
   // Toast Messages
   'toast.productAddedSimple': 'تمت إضافة المنتج',
   'toast.deliveryDatePastError': 'تاريخ التسليم لا يمكن أن يكون قبل اليوم',
   'toast.cardPaymentSuccessMsg': 'تم دفع البطاقة بنجاح!',
   'toast.cardPaymentFailed': 'فشل الدفع. الرجاء المحاولة مرة أخرى.',
   'toast.paymentStatusCheckError': 'تعذر التحقق من حالة الدفع. الرجاء التحقق من حسابك.',
   'toast.paymentStatusCheckErrorShort': 'تعذر التحقق من حالة الدفع.',
   'toast.changeToPickupSuccess': 'تم تغيير نوع التسليم إلى "استلام شخصي"',
   'toast.changeToPickupError': 'تعذر تغيير نوع التسليم',
   'toast.changeToDeliverySuccess': 'تم تغيير نوع التسليم إلى "توصيل للمنزل"',
   'toast.changeToDelivery': 'توصيل للمنزل',
   'toast.changeToPickup': 'استلام شخصي',
  'deliveryPage.changeDeliveryType': 'تغيير نوع التسليم',
  'zReport.todayRegistrations': 'تسجيلات اليوم',

  // المفاتيح المفقودة
  'common.allYears': 'جميع السنوات',
  'common.autoDetected': 'تم الاكتشاف تلقائياً',
  'common.cancelled': 'ملغى',
  'common.clear': 'مسح',
  'common.items': 'عناصر',
  'common.loadError': 'تعذّر التحميل',
  'common.none': 'لا شيء',
  'common.paid': 'مدفوع',
  'common.searchError': 'خطأ في البحث',
  'common.searchResults': '(نتائج البحث)',
  'common.unit': 'وحدة',
  'common.year': 'سنة',

  // كشف الحساب
  'accountStatement.allTime': 'كل الوقت',
  'accountStatement.customer': 'العميل',
  'accountStatement.customerReceipts': 'إيصالات العميل',
  'accountStatement.noData': 'لا توجد كشوف حساب',
  'accountStatement.noReceipts': 'لا توجد إيصالات',
  'accountStatement.payments': 'المدفوعات',
  'accountStatement.period': 'الفترة',
  'accountStatement.printStatement': 'طباعة كشف الحساب',
  'accountStatement.receipts': 'الإيصالات',
  'accountStatement.remaining': 'المتبقي',
  'accountStatement.statement': 'كشف الحساب',
  'accountStatement.totalPaid': 'إجمالي المدفوع',

  // الإعلانات
  'announcement.trialInfo': 'فترة التجربة نشطة',
  'announcement.welcome': 'مرحباً',

  // السمات
  'attributes.addColor': 'إضافة لون',
  'attributes.addDamage': 'إضافة ضرر',
  'attributes.addError': 'تعذّر الإضافة',
  'attributes.addStain': 'إضافة بقعة',
  'attributes.color': 'اللون',
  'attributes.deleteError': 'تعذّر حذف السمة',
  'attributes.deleted': 'تم حذف السمة',
  'attributes.loadError': 'تعذّر تحميل السمات',
  'attributes.name': 'اسم السمة',
  'attributes.noAttributes': 'لا توجد سمات محددة',
  'attributes.save': 'حفظ',
  'attributes.saveError': 'تعذّر حفظ السمات',
  'attributes.saved': 'تم حفظ السمات',
  'attributes.updateError': 'تعذّر التحديث',
  'attributes.value': 'القيمة',

  // كشف العميل
  'customerStatement.receiptDelivered': 'تم التسليم',
  'customerStatement.receiptOpen': 'مفتوح',

  // العملاء
  'customers.add': 'إضافة عميل',
  'customers.adres': 'العنوان',
  'customers.cannotDeleteWithOrders': 'لا يمكن حذف عميل لديه طلبات',
  'customers.import': 'استيراد',
  'customers.importTitle': 'استيراد العملاء',
  'customers.legacyHidden': 'مخفي (قديم)',
  'customers.notFound': 'العميل غير موجود',
  'customers.phoneMissing': 'رقم الهاتف مفقود',
  'customers.telefon': 'الهاتف',
  'customers.telefon2': 'الهاتف 2',

  // الأضرار
  'damage.add': 'إضافة ضرر',
  'damage.description': 'الوصف',
  'damage.location': 'الموقع',
  'damage.noPhoto': 'لا توجد صورة',
  'damage.photo': 'صورة',
  'damage.saveError': 'تعذّر حفظ تقرير الضرر',
  'damage.saved': 'تم حفظ تقرير الضرر',
  'damage.severity': 'الشدة',
  'damage.title': 'تقرير الضرر',
  'damage.type': 'نوع الضرر',

  // لوحة القيادة
  'dashboard.allTime': 'كل الوقت',
  'dashboard.referral.button': 'نسخ رابط الدعوة',
  'dashboard.referral.desc': 'شهر إضافي عندما يسجّل نشاط تجاري دعوته!',
  'dashboard.referral.title': 'دعوة الأصدقاء',

  // التوصيل
  'delivery.complete': 'تسليم',
  'delivery.deliveredItems': 'العناصر المسلّمة',
  'delivery.deliveredProducts': 'المنتجات المسلّمة',
  'delivery.error': 'خطأ في التوصيل',
  'delivery.loadError': 'تعذّر التحميل',
  'delivery.noOrders': 'لا توجد طلبات',
  'delivery.orderDelivered': 'تم تسليم الطلب',
  'delivery.orderReady': 'الطلب جاهز',
  'delivery.searchOrder': 'البحث عن طلب',
  'delivery.success': 'تم التوصيل بنجاح',
  'delivery.updateError': 'تعذّر التحديث',

  // قائمة التوصيل
  'deliveryList.address': 'العنوان',
  'deliveryList.cancelButton': 'إلغاء',
  'deliveryList.cancelConfirm': 'تأكيد الإلغاء',
  'deliveryList.cancelReasonPlaceholder': 'سبب الإلغاء...',
  'deliveryList.cancelTitle': 'إلغاء الطلب',
  'deliveryList.complete': 'إتمام',
  'deliveryList.completed': 'مكتمل',
  'deliveryList.delivered': 'تم التسليم',
  'deliveryList.deliveryError': 'خطأ في التوصيل',
  'deliveryList.driver': 'السائق',
  'deliveryList.items': 'العناصر',
  'deliveryList.messageError': 'خطأ في الرسالة',
  'deliveryList.orderCancelled': 'تم إلغاء الطلب',
  'deliveryList.orderDelivered': 'تم تسليم الطلب',
  'deliveryList.pending': 'قيد الانتظار',
  'deliveryList.phone': 'الهاتف',
  'deliveryList.selectDriver': 'اختر سائقاً',
  'deliveryList.status': 'الحالة',
  'deliveryList.title': 'قائمة التوصيل',
  'deliveryList.whatsappError': 'خطأ في واتساب',
  'deliveryList.whatsappSent': 'تم إرسال رسالة واتساب',

  // صفحة التوصيل
  'deliveryPage.changeDeliveryType': 'تغيير نوع التسليم',
  'deliveryPage.changeToDelivery': 'التحويل إلى توصيل',
  'deliveryPage.changeToDeliverySuccess': 'تم التحويل إلى توصيل',
  'deliveryPage.changeToPickup': 'التحويل إلى استلام',
  'deliveryPage.changeToPickupError': 'تعذّر التغيير',
  'deliveryPage.changeToPickupSuccess': 'تم التحويل إلى استلام',
  'deliveryPage.searchAll': 'الكل',
  'deliveryPage.searchBy': 'البحث بحسب',
  'deliveryPage.searchName': 'اسم العميل',
  'deliveryPage.searchNamePlaceholder': 'أدخل الاسم...',
  'deliveryPage.searchPhone': 'الهاتف',
  'deliveryPage.searchPhoneBtn': 'بحث بالهاتف',
  'deliveryPage.searchPlaceholder': 'بحث...',
  'deliveryPage.searchReceipt': 'رقم الإيصال',
  'deliveryPage.searchReceiptPlaceholder': 'أدخل رقم الإيصال...',

  // السائق
  'driver.searchHint': 'أدخل على الأقل حرفين',
  'driver.searchPlaceholder': 'رقم الإيصال، الاسم أو الهاتف...',

  // التذييل
  'footer.euServers': 'خوادم الاتحاد الأوروبي',
  'footer.gdpr': 'متوافق مع GDPR',

  // الفواتير
  'invoices.downloading': 'جارٍ التحميل...',

  // تسجيل الدخول
  'login.credentialsTitle': 'بيانات الدخول',
  'login.demoAccount': 'حساب تجريبي',
  'login.enterCredentials': 'أدخل بيانات الدخول',
  'login.forget': 'نسيت كلمة المرور؟',
  'login.saveCredentialsNote': 'تم حفظ بيانات الدخول بأمان',
  'login.tagline': 'برنامج التنظيف الجاف — حلول ذكية لعملك.',
  'login.usernamePlaceholder': 'أدخل اسم المستخدم...',

  // القائمة
  'menu.driverPickup': 'استلام السائق',
  'menu.hardware': 'الأجهزة',
  'menu.payment': 'الدفع',
  'menu.reportsCharts': 'التقارير والرسوم البيانية',

  // التنقل
  'nav.logout': 'تسجيل الخروج',
  'nav.user': 'المستخدم',

  // الإشعارات
  'notifications.customMessage': 'رسالة مخصصة',
  'notifications.failure': 'فشل إرسال الإشعار',
  'notifications.message': 'الرسالة',
  'notifications.preview': 'معاينة',
  'notifications.schedule': 'جدولة',
  'notifications.selectCustomer': 'اختر عميلاً',
  'notifications.send': 'إرسال',
  'notifications.sendNow': 'إرسال الآن',
  'notifications.sending': 'جارٍ الإرسال...',
  'notifications.sent': 'تم الإرسال',

  // الطلب
  'order.amount': 'المبلغ',
  'order.homeDelivery': 'توصيل للمنزل',
  'order.processing': 'جارٍ المعالجة...',
  'orderCreate.selectOperation': 'اختر عملية',
  'orderCreate.selectedOperations': 'العمليات المختارة',

  // الدفع
  'payment.bank': 'تحويل بنكي',
  'payment.adjustment': 'تسوية الرصيد',
  'payment.collect': 'تحصيل',
  'payment.credit': 'آجل',
  'payment.free': 'مجاني',
  'payment.paymentCare': 'دفعة الحساب الجاري',
  'payment.paymentsSaved': 'تم حفظ المدفوعات',
  'payment.saveError': 'تعذّر حفظ المدفوعات',
  'payment.saved': 'تم حفظ الدفعة',
  'payment.split': 'دفعة مقسّمة',

  // العناصر النائبة
  'placeholder.customerAddress': 'أدخل العنوان...',
  'placeholder.customerEmail': 'أدخل البريد الإلكتروني...',
  'placeholder.customerName': 'أدخل الاسم...',
  'placeholder.customerNotes': 'أدخل الملاحظات...',
  'placeholder.customerPhone': 'أدخل الهاتف...',

  // التسعير
  'pricing.amount': 'المبلغ',
  'pricing.enterPrice': 'أدخل السعر',
  'pricing.percent': 'نسبة مئوية',

  // المنتج
  'product.damage': 'ضرر',
  'product.stain': 'بقعة',

  // الإيصال
  'receipt.addressLabel': 'العنوان',
  'receipt.allYears': 'جميع السنوات',
  'receipt.area': 'المساحة',
  'receipt.backButton': 'رجوع',
  'receipt.buyCredits': 'شراء رصيد',
  'receipt.cancelled': 'ملغى',
  'receipt.cancelledBanner': 'تم إلغاء هذا الطلب',
  'receipt.cancelledBy': 'تم الإلغاء بواسطة',
  'receipt.cancelledDate': 'تاريخ الإلغاء',
  'receipt.cancelledReason': 'سبب الإلغاء',
  'receipt.card': 'بطاقة',
  'receipt.cash': 'نقداً',
  'receipt.change': 'الباقي',
  'receipt.connect': 'اتصال',
  'receipt.connected': 'متصل',
  'receipt.copyButton': 'نسخ',
  'receipt.copySend': 'نسخ وإرسال',
  'receipt.copyTip': 'نسخ الرسالة',
  'receipt.creditsFinished': 'نفد رصيد واتساب!',
  'receipt.customer': 'العميل',
  'receipt.customerInfo': 'معلومات العميل',
  'receipt.customerName': 'اسم العميل',
  'receipt.deliveryDate': 'تاريخ التسليم',
  'receipt.discount': 'خصم',
  'receipt.discountedTotal': 'المبلغ بعد الخصم',
  'receipt.footerNote': 'ملاحظة',
  'receipt.freeOfCharge': 'مجاني',
  'receipt.generalTotal': 'المجموع الكلي',
  'receipt.goToWhatsAppPage': 'الذهاب لصفحة واتساب؟',
  'receipt.grandTotal': 'الإجمالي النهائي',
  'receipt.homeDelivery': 'توصيل للمنزل',
  'receipt.invalid': 'إيصال غير صالح',
  'receipt.items': 'العناصر',
  'receipt.label': 'ملصق',
  'receipt.labelPrinted': 'تم طباعة الملصق',
  'receipt.markAsDelivered': 'وضع علامة مسلّم',
  'receipt.markAsReady': 'وضع علامة جاهز',
  'receipt.markDeliveredError': 'خطأ في وضع علامة مسلّم',
  'receipt.markReadyError': 'خطأ في وضع علامة جاهز',
  'receipt.messageFailed': 'فشل إرسال الرسالة',
  'receipt.messageSendFailed': 'تعذّر إرسال الرسالة',
  'receipt.messageSent': 'تم إرسال الرسالة!',
  'receipt.new': 'إيصال جديد',
  'receipt.noCollection': 'لا يوجد تجميع',
  'receipt.noReceiptFound': 'لم يُعثر على إيصال',
  'receipt.notes': 'ملاحظات',
  'receipt.onlyProEnterprise': 'Pro/Enterprise فقط',
  'receipt.openWhatsApp': 'فتح واتساب',
  'receipt.orderMarkedDelivered': 'تم وضع علامة مسلّم على الطلب',
  'receipt.orderMarkedReady': 'تم وضع علامة جاهز على الطلب',
  'receipt.orderNumber': 'رقم الطلب',
  'receipt.orderReceived': 'تم استلام الطلب',
  'receipt.paid': 'مدفوع',
  'receipt.partialPayment': 'دفع جزئي',
  'receipt.paymentMethod': 'طريقة الدفع',
  'receipt.phone': 'الهاتف',
  'receipt.phoneNotFound': 'رقم الهاتف غير موجود',
  'receipt.piece': 'قطعة',
  'receipt.preview': 'معاينة',
  'receipt.printError': 'خطأ في الطباعة',
  'receipt.printerConnectError': 'تعذّر الاتصال بالطابعة',
  'receipt.productsInfo': 'المنتجات',
  'receipt.receiptInfo': 'معلومات الإيصال',
  'receipt.remaining': 'المتبقي',
  'receipt.remainingCredits': 'الرصيد المتبقي',
  'receipt.reprint': 'إعادة الطباعة',
  'receipt.scanQR': 'مسح رمز QR',
  'receipt.searchAll': 'الكل',
  'receipt.searchBy': 'البحث بحسب',
  'receipt.searchError': 'خطأ في البحث',
  'receipt.searchName': 'اسم العميل',
  'receipt.searchPhone': 'الهاتف',
  'receipt.searchReceipt': 'رقم الإيصال',
  'receipt.searchReceiptPlaceholder': 'أدخل رقم الإيصال...',
  'receipt.searchTitle': 'البحث عن إيصال',
  'receipt.selectAll': 'تحديد الكل',
  'receipt.serviceSummary': 'ملخص الخدمات',
  'receipt.sessionNotFound': 'الجلسة غير موجودة. يرجى تسجيل الدخول مجدداً.',
  'receipt.status': 'الحالة',
  'receipt.thermalPrinter': 'طابعة حرارية',
  'receipt.thisReceiptCancelled': 'تم إلغاء هذا الإيصال',
  'receipt.unknownError': 'خطأ غير معروف',
  'receipt.whatsappFeature': 'ميزة واتساب',
  'receipt.whatsappNotConnected': 'واتساب غير متصل!',
  'receipt.whatsappPreview': 'معاينة واتساب',
  'receipt.whatsappPreviewDesc': 'معاينة الرسالة',
  'receipt.whatsappPreviewTitle': 'معاينة',
  'receipt.year': 'السنة',

  // التقارير
  'reports.averageOrder': 'متوسط الطلب',
  'reports.ordersCount': 'عدد الطلبات',
  'reports.salesReport': 'تقرير المبيعات',
  'reports.totalSales': 'إجمالي المبيعات',

  // الخدمات
  'service.carpetShort': 'سجادة',
  'service.dryCleaningShort': 'تنظيف',
  'service.ironingShort': 'كوي',
  'service.dyeingShort': 'صباغة',
  'service.shoeShineShort': 'أحذية',
  'service.tailoringShort': 'خياطة',
  'service.washingShort': 'غسيل',

  // الإعدادات
  'settings.africa': 'أفريقيا',
  'settings.americas': 'الأمريكتان',
  'settings.asia': 'آسيا',
  'settings.asiaPacific': 'آسيا والمحيط الهادئ',
  'settings.asianLanguages': 'اللغات الآسيوية',
  'settings.autoConnect': 'اتصال تلقائي',
  'settings.browserNotSupported': 'المتصفح غير مدعوم',
  'settings.callerId': 'معرّف المتصل',
  'settings.company': 'الشركة',
  'settings.europe': 'أوروبا',
  'settings.integrations': 'التكاملات',
  'settings.notifications': 'الإشعارات',
  'settings.printer': 'الطابعة',
  'settings.printerConnect': 'اتصال الطابعة',
  'settings.printerConnected': 'الطابعة متصلة',
  'settings.printerConnection': 'اتصال الطابعة',
  'settings.printerDisconnect': 'قطع اتصال الطابعة',
  'settings.printerModel': 'موديل الطابعة',
  'settings.printerNotConnected': 'الطابعة غير متصلة',
  'settings.printerSettings': 'إعدادات الطابعة',
  'settings.saveError': 'تعذّر حفظ الإعدادات',
  'settings.saved': 'تم حفظ الإعدادات',
  'settings.testPrint': 'طباعة تجريبية',
  'settings.turkey': 'تركيا',

  // التسجيل
  'signup.errors.companyCodeRequired': 'رمز الشركة مطلوب',
  'signup.errors.companyNameRequired': 'اسم الشركة مطلوب',
  'signup.errors.emailInvalid': 'البريد الإلكتروني غير صالح',
  'signup.errors.emailRequired': 'البريد الإلكتروني مطلوب',
  'signup.errors.ownerNameRequired': 'اسم المالك مطلوب',
  'signup.errors.signupFailed': 'فشل التسجيل',
  'signup.referral.bonus': 'مكافأة الإحالة',
  'signup.referral.title': 'رمز الدعوة',
  'signup.companyDetails': 'بيانات الشركة',
  'signup.errors.companyCodeTooShort': 'يجب أن يتكون رمز الشركة من 3 أحرف على الأقل',
  'signup.fields.companyCode': 'رمز الشركة',
  'signup.fields.companyName': 'اسم الشركة',
  'signup.fields.country': 'الدولة',
  'signup.fields.email': 'البريد الإلكتروني',
  'signup.fields.ownerName': 'الاسم الكامل',
  'signup.fields.phone': 'رقم الهاتف',
  'signup.haveAccount': 'لديك حساب بالفعل؟ سجّل الدخول',
  'signup.placeholders.companyCode': 'مثال: cleanpro',
  'signup.placeholders.companyName': 'مثال: CleanPro للتنظيف الجاف',
  'signup.placeholders.email': 'مثال: ali@cleanpro.com',
  'signup.placeholders.ownerName': 'مثال: علي أحمد',
  'signup.placeholders.phone': 'مثال: +966 50 123 4567',

  // الحالة
  'status.cancelled': 'ملغى',
  'status.delivered': 'تم التسليم',
  'status.pending': 'قيد الانتظار',
  'status.pickup_in_progress': 'الاستلام جارٍ',
  'status.pickup_pending': 'الاستلام معلق',
  'status.ready': 'جاهز',
  'status.received': 'تم الاستلام',

  // الاشتراك
  'subscription.buyNow': 'اشترِ الآن',
  'subscription.cancel': 'إلغاء الاشتراك',
  'subscription.contactSales': 'تواصل مع المبيعات',
  'subscription.contactSupport': 'تواصل مع الدعم',
  'subscription.currentPlan': 'الخطة الحالية',
  'subscription.currentUsage': 'الاستخدام الحالي',
  'subscription.daysLeft': 'أيام متبقية',
  'subscription.downgrade': 'خفض الخطة',
  'subscription.endDate': 'تاريخ الانتهاء',
  'subscription.expired': 'منتهي الصلاحية',
  'subscription.expiredOn': 'انتهى في',
  'subscription.expiresOn': 'ينتهي في',
  'subscription.features': 'الميزات',
  'subscription.loading': 'جارٍ تحميل الاشتراك...',
  'subscription.monthly': 'شهري',
  'subscription.monthlyLimit': 'الحد الشهري',
  'subscription.noSubscription': 'لا يوجد اشتراك نشط',
  'subscription.payNow': 'ادفع الآن',
  'subscription.plan': 'الخطة',
  'subscription.popular': 'شائع',
  'subscription.pro': 'Pro',
  'subscription.renew': 'تجديد',
  'subscription.renewNow': 'جدّد الآن',
  'subscription.startDate': 'تاريخ البدء',
  'subscription.title': 'الاشتراك',
  'subscription.trial': 'تجريبي',
  'subscription.trialDaysLeft': 'أيام تجريبية متبقية',
  'subscription.trialEnd': 'انتهاء التجربة',
  'subscription.upgrade': 'ترقية',
  'subscription.yearly': 'سنوي',

  // تذاكر الدعم
  'tickets.title': 'تذاكر الدعم',
  'tickets.newTicket': 'تذكرة جديدة',
  'tickets.noTickets': 'لا توجد تذاكر',
  'tickets.noTicketsDesc': 'ليس لديك تذاكر دعم بعد',
  'tickets.subject': 'الموضوع',
  'tickets.subjectPlaceholder': 'موضوع الدعم...',
  'tickets.description': 'الوصف',
  'tickets.descriptionPlaceholder': 'اشرح مشكلتك بالتفصيل...',
  'tickets.fillAllFields': 'يرجى ملء جميع الحقول',
  'tickets.created': 'تم إنشاء تذكرة الدعم',
  'tickets.createError': 'تعذّر إنشاء تذكرة الدعم',
  'tickets.loadError': 'تعذّر تحميل التذاكر',
  'tickets.sendError': 'تعذّر إرسال الرسالة',
  'tickets.messages': 'الرسائل',
  'tickets.conversation': 'المحادثة',
  'tickets.typeMessage': 'اكتب رسالتك...',
  'tickets.closed': 'مغلق',
  'tickets.closedMessage': 'تم إغلاق هذه التذكرة.',
  'tickets.admin': 'المسؤول',
  'tickets.yourName': 'اسمك',
  'tickets.yourNamePlaceholder': 'أدخل اسمك...',
  'tickets.rateExperience': 'قيّم تجربتك',
  'tickets.rateDescription': 'قيّم تجربة الدعم',
  'tickets.rateSupport': 'تقييم الدعم',
  'tickets.selectRating': 'اختر تقييماً',
  'tickets.yourRating': 'تقييمك',
  'tickets.ratingSubmitted': 'تم حفظ تقييمك، شكراً!',
  'tickets.ratingError': 'تعذّر حفظ التقييم',
  'tickets.translationError': 'خطأ في الترجمة',
  'tickets.status.open': 'مفتوح',
  'tickets.status.closed': 'مغلق',
  'tickets.status.investigating': 'قيد الفحص',
  'tickets.status.waitingCustomer': 'في انتظار العميل',
  'tickets.rating.veryBad': 'سيء جداً',
  'tickets.rating.bad': 'سيء',
  'tickets.rating.okay': 'مقبول',
  'tickets.rating.good': 'جيد',
  'tickets.rating.excellent': 'ممتاز',

  // Toast
  'toast.logoTooLarge': 'ملف الشعار كبير جداً',
  'toast.logoUploadError': 'تعذّر رفع الشعار',
  'toast.uploadingLogo': 'جارٍ رفع الشعار...',

  // واتساب
  'whatsapp.title': 'واتساب',
  'whatsapp.connect': 'ربط واتساب',
  'whatsapp.disconnect': 'قطع الاتصال',
  'whatsapp.connected': 'متصل',
  'whatsapp.disconnected': 'غير متصل',
  'whatsapp.scanQR': 'مسح رمز QR',
  'whatsapp.status': 'الحالة',
  'whatsapp.credits': 'الرصيد',
  'whatsapp.buyCredits': 'شراء رصيد',
  'whatsapp.creditPackages': 'باقات الرصيد',
  'whatsapp.messages': 'رسائل',
  'whatsapp.creditsRemaining': 'رصيد متبقٍ',
  'whatsapp.noCredits': 'لا يوجد رصيد',
  'whatsapp.sendTest': 'إرسال رسالة اختبار',
  'whatsapp.testSent': 'تم إرسال رسالة الاختبار',
  'whatsapp.testFailed': 'فشل إرسال رسالة الاختبار',
  'whatsapp.templates': 'القوالب',
  'whatsapp.template': 'قالب',
  'whatsapp.preview': 'معاينة',
  'whatsapp.save': 'حفظ القالب',
  'whatsapp.saved': 'تم حفظ القالب',
  'whatsapp.orderReady': 'الطلب جاهز',
  'whatsapp.orderDelivered': 'تم تسليم الطلب',
  'whatsapp.receiptCreated': 'تم إنشاء الإيصال',

  // تقرير Z
  'zReport.title': 'تقرير Z',
  'zReport.period': 'الفترة',
  'zReport.byEmployee': 'حسب الموظف',
  'zReport.byProduct': 'حسب المنتج',
  'zReport.byService': 'حسب الخدمة',
  'zReport.cardPayments': 'مدفوعات البطاقة',
  'zReport.cashIn': 'وارد',
  'zReport.cashOut': 'صادر',
  'zReport.cashPayments': 'مدفوعات نقدية',
  'zReport.closingBalance': 'الرصيد الختامي',
  'zReport.creditPayments': 'مدفوعات آجلة',
  'zReport.custom': 'مخصص',
  'zReport.daily': 'يومي',
  'zReport.endDate': 'تاريخ الانتهاء',
  'zReport.free': 'مجاني',
  'zReport.freeOrders': 'الطلبات المجانية',
  'zReport.generateReport': 'إنشاء التقرير',
  'zReport.monthly': 'شهري',
  'zReport.newCustomers': 'عملاء جدد',
  'zReport.noData': 'لا توجد بيانات لهذه الفترة',
  'zReport.openingBalance': 'الرصيد الافتتاحي',
  'zReport.printReport': 'طباعة التقرير',
  'zReport.returningCustomers': 'العملاء المترددون',
  'zReport.selectDate': 'اختر التاريخ',
  'zReport.serviceBreakdown': 'تفاصيل الخدمات',
  'zReport.startDate': 'تاريخ البداية',
  'zReport.totalCollected': 'إجمالي المحصّل',
  'zReport.totalItems': 'إجمالي العناصر',
  'zReport.totalOrders': 'إجمالي الطلبات',
  'zReport.totalRefunds': 'إجمالي المستردات',
  'zReport.totalRevenue': 'إجمالي الإيرادات',
  'zReport.transferPayments': 'مدفوعات التحويل',
  'zReport.weekly': 'أسبوعي',
  'zreport.card': 'بطاقة',
  'zreport.cash': 'نقداً',
  'zreport.date': 'التاريخ',
  'zreport.orders': 'الطلبات',
  'zreport.print': 'طباعة',
  'zreport.title': 'تقرير Z',
  'zreport.total': 'الإجمالي',

  'zReport.cashBoxStartNote': 'رصيد الصندوق الافتتاحي',
  'zReport.todayCashNote': 'النقد المستلم اليوم',
  'zReport.branchCollectionsNote': 'تحصيلات الفرع + فروع أخرى',
  'zReport.dailyExpensesNote': 'مصاريف اليوم',
  'customerCard.balanceZero': 'الرصيد صفر بالفعل.',
  'customerCard.debtLabel': 'سيتم محو الدين',
  'customerCard.creditLabel': 'سيتم محو الرصيد الدائن',
  'customerCard.resetConfirm': 'سيتم إعادة تعيين الرصيد ({label}). تأكيد؟',
  'customerCard.resetSuccess': 'تم إعادة تعيين الرصيد',
  'customerCard.resetError': 'تعذر إعادة تعيين الرصيد',
  'customerCard.printTitle': 'بطاقة العميل',
  'customerCard.heading': 'بطاقة العميل',
  'customerCard.tel1': 'هاتف 1',
  'customerCard.tel2': 'هاتف 2',
  'customerCard.address': 'العنوان',
  'customerCard.printButton': 'طباعة بطاقة العميل',
  'customerCard.resetting': 'جارٍ الإعادة...',
  'customerCard.resetBalance': 'إعادة تعيين الرصيد',
  'tailoring.loadError': 'تعذر تحميل الأسعار',
  'tailoring.nameRequired': 'الرجاء إدخال اسم العملية',
  'tailoring.invalidPrice': 'الرجاء إدخال سعر صحيح',
  'tailoring.addSuccess': 'تمت إضافة عملية خياطة جديدة!',
  'tailoring.saveError': 'خطأ في الحفظ',
  'tailoring.deleteConfirm': 'هل أنت متأكد من حذف هذه العملية؟',
  'tailoring.deleteSuccess': 'تم حذف العملية',
  'tailoring.deleteError': 'خطأ في الحذف',
  'tailoring.saveSuccess': 'تم حفظ أسعار الخياطة!',
  'tailoring.addNewTitle': 'إضافة عملية خياطة جديدة',
  'tailoring.operationNameLabel': 'اسم العملية',
  'tailoring.priceLabel': 'السعر',
  'tailoring.iconLabel': 'أيقونة (Emoji)',
  'tailoring.operationNamePlaceholder': 'مثال: خياطة الياقة',
  'tailoring.savePricesHint': 'انقر على حفظ لحفظ الأسعار',
  'tailoring.addCustomHint': 'استخدم زر + لإضافة عملية مخصصة',
  'reportsList.title': 'قائمة الفواتير',
  'reportsList.startDate': 'تاريخ البدء',
  'reportsList.endDate': 'تاريخ الانتهاء',
  'reportsList.search': 'بحث',
  'reportsList.loading': 'جارٍ التحميل...',
  'reportsList.description': 'يتم سرد جميع الفواتير المسجلة أو المسلمة في هذا النطاق الزمني',
  'reportsList.empty': 'لم يتم العثور على فواتير في هذا النطاق الزمني',
  'reportsList.changeDateRange': 'حدد نطاقًا زمنيًا مختلفًا',
  'reportsList.categoryBreakdown': 'توزيع حسب الفئة',
  'reportsList.unknown': 'غير معروف',
  'reportsList.cancelReason': 'سبب الإلغاء:',
  'reportsList.excelDownloaded': 'تم تنزيل ملف Excel',
  'reportsList.excelError': 'تعذر إنشاء ملف Excel',
  'reportsList.totalReceipt': 'إجمالي الفواتير',
  'reportsList.activeReceipt': 'الفواتير النشطة',
  'reportsList.loadError': 'تعذر تحميل قائمة الفواتير',
  'reportsList.dateError': 'لا يمكن أن يكون تاريخ البدء بعد تاريخ الانتهاء',
  'charts.revenue': 'الإيرادات',
  'charts.orders': 'الطلبات',
  'charts.pieces': 'عدد القطع',
  'charts.receipts': 'عدد الفواتير',
  'charts.loadError': 'تعذر تحميل البيانات',

  'customerStatement.selectDateRange': 'اختر نطاق التاريخ',
  'customerStatement.thisMonth': 'هذا الشهر',
  'customerStatement.lastMonth': 'الشهر الماضي',
  'customerStatement.allTime': 'كل الأوقات',
  'customerStatement.startDate': 'تاريخ البداية',
  'customerStatement.endDate': 'تاريخ النهاية',
  'customerStatement.printPDF': 'طباعة الكشف (PDF)',
  'customerStatement.title': 'كشف الحساب',
  'customerStatement.customerName': 'اسم العميل',
  'customerStatement.phone': 'الهاتف',
  'customerStatement.address': 'العنوان',
  'customerStatement.openingBalance': 'الرصيد الافتتاحي',
  'customerStatement.closingBalance': 'الرصيد الختامي',
  'customerStatement.description': 'الوصف',
  'customerStatement.type': 'النوع',
  'customerStatement.debit': 'مدين',
  'customerStatement.credit': 'دائن (المحصّل)',
  'customerStatement.total': 'المجموع',
  'customerStatement.cancelled': 'ملغى',
  'customerStatement.payment': 'دفع',
  'customerStatement.items': 'عناصر',
  'customerStatement.noTransactions': 'لا توجد معاملات في الفترة المحددة.',
  'customerStatement.statementDate': 'تاريخ الكشف',

  'tailoring.title': 'خدمات الخياطة',
  'tailoring.addNew': 'عملية جديدة',
  'tailoring.subtitle': 'يمكنك هنا تحديث أسعار خدمات الخياطة',
  'tailoring.addNewDescription': 'إضافة نوع عملية خياطة مخصص',
  'tailoring.add': 'إضافة',
  'tailoring.savePrices': 'حفظ الأسعار',
  'tailoring.default': 'افتراضي',
  'tailoring.infoTitle': 'معلومات',
  'tailoring.info1': 'بعد تغيير الأسعار، انقر على "حفظ الأسعار"',
  'tailoring.info2': 'يمكنك إضافة أنواع عمليات خياطة مخصصة بزر "عملية جديدة"',
  'tailoring.info3': 'يمكن حذف العمليات المخصصة بأيقونة سلة المهملات',
  'tailoring.info4': 'تُستخدم هذه الأسعار عند إنشاء الطلبات بخدمة الخياطة',
  'tailoring.info5': 'يمكنك تحديد سعر منفصل لكل عملية خياطة',
  'tailoring.info6': 'يتم احتساب الأسعار تلقائياً عند الإضافة إلى السلة',

  'hardware.title': 'متجر الأجهزة',
  'hardware.subtitle': 'طابعات الإيصالات والملصقات وأجهزة معرّف المتصل',
  'hardware.cart': 'السلة',
  'hardware.infoTitle': 'معلومات',
  'hardware.infoText': 'هذه المنتجات متاحة للشراء حالياً في تركيا فقط. مدرجة لأغراض إعلامية للدول الأخرى.',
  'hardware.myCart': 'سلتي',
  'hardware.cartEmpty': 'السلة فارغة',
  'hardware.vatSuffix': '+ ضريبة',
  'hardware.total': 'المجموع',
  'hardware.checkout': 'المتابعة للدفع',
  'hardware.receiptPrinters': 'طابعات الإيصالات',
  'hardware.receiptPrintersSubtitle': 'طابعات حرارية 80 ملم مع قاطع تلقائي',
  'hardware.compatibilityTitle': 'توافق CleandySoft',
  'hardware.receiptCompatText': 'يعمل مع جميع الطابعات الحرارية 80 ملم مع قاطع تلقائي.',
  'hardware.labelPrinters': 'طابعات الملصقات',
  'hardware.labelPrintersSubtitle': 'طابعات نقطية، 76مم/57مم (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'الموديلات المختبرة',
  'hardware.labelCompatText': 'تم الاختبار لـ Epson TM-U220 و Bixolon SRP-270. قد تواجه الماركات الأخرى مشاكل.',
  'hardware.callerIdTitle': 'أجهزة معرّف المتصل',
  'hardware.callerIdSubtitle': 'التعرف على المتصلين من العملاء',
  'hardware.compatibilityNote': 'ملاحظة التوافق',
  'hardware.callerIdCompatText': 'تم الاختبار فقط لموديل CIDShow 2 خطوط. قد تعمل ماركات أخرى لكن غير مضمونة.',
  'hardware.barcodeScanners': 'ماسحات الباركود',
  'hardware.barcodeScannerSubtitle': 'ماسحات USB للباركود ورموز QR',
  'hardware.barcodeCompatText': 'جميع ماسحات 2D يمكنها العمل مع CleandySoft. الماسحات في وضع USB HID مدعومة تلقائياً.',
  'hardware.driverDownloads': 'تحميلات التعريفات والبرامج',
  'hardware.driverDownloadsText': 'يُنصح بتحميل التعريف المناسب قبل توصيل الطابعة.',
  'hardware.onlyTurkey': 'هذا المنتج متاح للشراء في تركيا فقط',
  'hardware.addedToCart': 'تمت الإضافة إلى السلة!',
  'hardware.available': 'متاح',
  'hardware.info': 'معلومات',
  'hardware.features': 'المميزات',
  'hardware.addToCart': 'أضف إلى السلة',
  'hardware.infoOnly': 'للاطلاع فقط',
  'expenses.expenseType': 'نوع المصروف',
  'expenses.allBranches': 'جميع الفروع',
  'expenses.noBranch': 'بدون فرع',
  'expenses.allTypes': 'جميع الأنواع',
  'expenses.categoryBy': 'حسب الفئة',
  'expenses.records': 'سجل',
  'expenses.exportExcel': 'إكسل',
  'expenses.excelError': 'تعذر إنشاء ملف Excel',
  'expenses.branchSelect': 'اختر الفرع',
  'expenses.noBranchSelected': '— لم يتم اختيار فرع —',
  'expenses.myBranch': 'فرعي',
  'expenses.canOnlyDeleteToday': 'يمكنك فقط حذف المصروفات التي أدخلتها اليوم.',
  // ---- eksik çeviriler (2026-10-14) ----
  'accountStatement.addPayment': 'إضافة دفعة',
  'accountStatement.balance': 'الرصيد',
  'accountStatement.changeCustomer': 'تغيير العميل',
  'accountStatement.credit': 'دائن',
  'accountStatement.currentBalance': 'الرصيد الحالي',
  'accountStatement.customerPlaceholder': 'اختر عميلاً...',
  'accountStatement.date': 'التاريخ',
  'accountStatement.debit': 'مدين',
  'accountStatement.description': 'الوصف',
  'accountStatement.exportStatement': 'تنزيل كشف الحساب',
  'accountStatement.exportStatementPDF': 'تنزيل PDF',
  'accountStatement.loadError': 'تعذر تحميل الحساب الجاري',
  'accountStatement.noCustomerSelected': 'يرجى اختيار عميل',
  'accountStatement.noCustomersFound': 'لم يتم العثور على عملاء',
  'accountStatement.noTransactions': 'لا توجد حركات لهذا العميل',
  'accountStatement.order': 'الطلب',
  'accountStatement.payment': 'الدفعة',
  'accountStatement.paymentAmount': 'مبلغ الدفعة',
  'accountStatement.paymentError': 'تعذر حفظ الدفعة',
  'accountStatement.paymentMethod': 'طريقة الدفع',
  'accountStatement.paymentNotes': 'الوصف (اختياري)',
  'accountStatement.paymentSaved': 'تم حفظ الدفعة',
  'accountStatement.recordPayment': 'تسجيل دفعة',
  'accountStatement.searchCustomer': 'ابحث بالاسم أو الهاتف أو العنوان...',
  'accountStatement.searchHint': 'أدخل حرفين على الأقل للبحث عن عميل',
  'accountStatement.selectCustomer': 'اختر العميل',
  'accountStatement.selectCustomerFirst': 'اختر عميلاً أولاً',
  'accountStatement.selectedCustomer': 'العميل المحدد',
  'accountStatement.subtitle': 'متابعة المدين والدائن لكل عميل',
  'accountStatement.title': 'كشف الحساب',
  'accountStatement.totalDebt': 'إجمالي الدين',
  'accountStatement.totalPayments': 'إجمالي المدفوعات',
  'accountStatement.transactions': 'الحركات',
  'areaCalculation.calculatedArea': 'المساحة المحسوبة:',
  'areaCalculation.carpetCount': '🔢 عدد السجاد',
  'areaCalculation.carpetCountPlaceholder': 'كم عدد السجاد؟',
  'areaCalculation.continue': 'متابعة',
  'areaCalculation.directInput': '📏 إدخال م² مباشرة',
  'areaCalculation.exampleNumber': 'مثال: 4',
  'areaCalculation.exampleSqM': 'مثال: 12.5',
  'areaCalculation.height': 'الطول (م)',
  'areaCalculation.or': 'أو',
  'areaCalculation.perCarpet': 'لكل سجادة',
  'areaCalculation.title': 'حساب المساحة',
  'areaCalculation.total': 'الإجمالي',
  'areaCalculation.totalSqM': '📏 إجمالي م² (لـ {count} سجادة)',
  'areaCalculation.width': 'العرض (م)',
  'attributes.add': 'إضافة خاصية',
  'attributes.colors': 'الألوان',
  'attributes.damages': 'أنواع التلف',
  'attributes.stains': 'أنواع البقع',
  'attributes.title': 'الخصائص',
  'back': 'رجوع',
  'cancel': 'إلغاء',
  'changePin': 'تغيير رمز PIN',
  'changingPin': 'جارٍ التغيير...',
  'charts.branchRevenue': 'الإيرادات حسب الفرع',
  'charts.cashCard': 'نقداً + بطاقة ائتمان',
  'charts.cashCardAtDel': '💵 نقداً/بطاقة (عند التسليم):',
  'charts.cashCardAtReg': '💵 نقداً/بطاقة (عند التسجيل):',
  'charts.collectionSummary': 'ملخص التحصيل',
  'charts.currentCollections': '📋 تحصيل الحسابات الجارية:',
  'charts.customer': 'العميل',
  'charts.dailyItems': 'رسم بياني لعدد القطع اليومي',
  'charts.dailyRevenue': 'رسم بياني للإيرادات اليومية',
  'charts.graphicReports': 'التقارير البيانية',
  'charts.itemCount': 'عدد القطع',
  'charts.noData': 'لا توجد بيانات في هذه الفترة',
  'charts.periodSuffix': 'فترة',
  'charts.regDelivery': '(تسجيل + تسليم)',
  'charts.selectPeriod': 'اختر فترة أخرى',
  'charts.top10Customers': 'أعلى 10 عملاء من حيث الإيرادات',
  'charts.total': 'الإجمالي',
  'charts.totalItems': 'إجمالي القطع',
  'charts.totalReceipts': 'إجمالي الإيصالات',
  'charts.totalRevenue': 'إجمالي الإيرادات',
  'common.exportExcel': 'تنزيل Excel',
  'common.exportToExcel': 'تصدير إلى Excel',
  'common.ok': 'موافق',
  'common.printDate': 'تاريخ الطباعة',
  'confirmPin': 'تأكيد رمز PIN',
  'create': 'إنشاء',
  'currentPin': 'رمز PIN الحالي',
  'customers.actions': 'الإجراءات',
  'customers.addError': 'تعذرت إضافة العميل',
  'customers.addNew': 'عميل جديد',
  'customers.added': 'تمت إضافة العميل',
  'customers.address': 'العنوان',
  'customers.balance': 'الرصيد',
  'customers.delete': 'حذف',
  'customers.deleteConfirm': 'هل أنت متأكد من حذف العميل "{name}"؟',
  'customers.deleteError': 'تعذر حذف العميل',
  'customers.deleted': 'تم حذف العميل',
  'customers.edit': 'تعديل',
  'customers.email': 'البريد الإلكتروني',
  'customers.loadError': 'تعذر تحميل العملاء',
  'customers.name': 'الاسم',
  'customers.noCustomers': 'لم يتم العثور على عملاء',
  'customers.noResults': 'لا توجد نتائج',
  'customers.notes': 'ملاحظة',
  'customers.phone': 'الهاتف',
  'customers.search': 'البحث عن العملاء...',
  'customers.searchPlaceholder': 'ابحث بالاسم أو الهاتف أو البريد الإلكتروني أو العنوان... (مثال: john+5551234567)',
  'customers.showingFirst50': 'عرض أول 50 نتيجة',
  'customers.smsEnabled': 'SMS',
  'customers.tableActions': 'الإجراءات',
  'customers.tableAddress': 'العنوان',
  'customers.tableBalance': 'الرصيد',
  'customers.tableContact': 'التواصل',
  'customers.tableCustomer': 'العميل',
  'customers.tableNotifications': 'الإشعارات',
  'customers.title': 'العملاء',
  'customers.totalCount': 'إجمالي {count} عميل',
  'customers.totalOrders': 'عدد الطلبات',
  'customers.totalResults': 'الإجمالي',
  'customers.totalSpent': 'إجمالي الإنفاق',
  'customers.updateError': 'تعذر تحديث العميل',
  'customers.updated': 'تم تحديث العميل',
  'customers.whatsappEnabled': 'WhatsApp',
  'damage.burn': 'حرق',
  'damage.button': 'مشكلة في الأزرار',
  'damage.buttonMissing': 'زر مفقود',
  'damage.color': 'انتقال اللون',
  'damage.delik': 'ثقب',
  'damage.fade': 'بهتان',
  'damage.fray': 'اهتراء الحواف',
  'damage.hole': 'ثقب',
  'damage.lining': 'البطانة',
  'damage.multiple': 'حالة التلف (يمكن اختيار أكثر من خيار)',
  'damage.none': 'لا يوجد',
  'damage.other': 'تلف آخر...',
  'damage.pembe': 'بقعة وردية',
  'damage.seam': 'خياطة',
  'damage.stain': 'بقعة',
  'damage.tear': 'تمزق',
  'damage.worn': 'تآكل',
  'damage.zipper': 'سحّاب',
  'delivery.actions': 'الإجراءات',
  'delivery.customer': 'العميل',
  'delivery.delivered': 'تم التسليم',
  'delivery.deliveryDate': 'تاريخ التسليم',
  'delivery.items': 'المنتجات',
  'delivery.markDelivered': 'تحديد كمُسلَّم',
  'delivery.markReady': 'تحديد كجاهز',
  'delivery.orderNumber': 'رقم الطلب',
  'delivery.pending': 'قيد المعالجة',
  'delivery.printReceipt': 'طباعة الإيصال',
  'delivery.ready': 'جاهز',
  'delivery.status': 'الحالة',
  'delivery.title': 'إدارة التسليم',
  'delivery.total': 'الإجمالي',
  'deliveryList.all': 'الكل',
  'deliveryList.amount': 'المبلغ',
  'deliveryList.branchUpdated': 'تم تحديث فرع التسليم',
  'deliveryList.cancelError': 'خطأ في الإلغاء',
  'deliveryList.changeBranch': 'تغيير فرع التسليم',
  'deliveryList.date': 'التاريخ',
  'deliveryList.homeDelivery': 'إلى العنوان',
  'deliveryList.loadError': 'تعذر تحميل الطلبات',
  'deliveryList.noBranch': 'لم يتم اختيار فرع',
  'deliveryList.noBranchAssigned': 'لم يتم تعيين فرع',
  'deliveryList.noOrders': 'لا توجد طلبات للتسليم',
  'deliveryList.noPhone': 'لم يتم العثور على هاتف العميل',
  'deliveryList.pickup': 'استلام',
  'deliveryList.pieces': 'قطعة',
  'deliveryList.ready': 'جاهز',
  'deliveryList.readyButton': 'جاهز',
  'deliveryList.receiptButton': 'إيصال',
  'deliveryList.search': 'رقم الإيصال أو اسم العميل أو الهاتف...',
  'deliveryList.selectBranch': 'اختر الفرع',
  'deliveryList.smsSent': '📨 تم إرسال رسالة SMS',
  'deliveryList.statusUpdateError': 'تعذر تحديث الحالة',
  'deliveryList.statusUpdated': 'تم تحديد الطلب كجاهز',
  'deliveryList.updateError': 'تعذر التحديث',
  'deliveryList.waRemind': 'تذكير عبر WA',
  'deliveryList.whatsappFailed': 'تعذر الإرسال عبر WhatsApp',
  'deliveryList.whatsappSending': '📱 جارٍ إرسال رسالة WhatsApp...',
  'deliveryList.whatsappTimeout': 'انتهت مهلة طلب WhatsApp',
  'deliveryPage.amount': 'المبلغ',
  'deliveryPage.deliverButton': 'تسليم المحدد',
  'deliveryPage.deliveryError': 'خطأ في التسليم',
  'deliveryPage.deliverySuccess': 'تم التسليم بنجاح',
  'deliveryPage.itemsList': 'قائمة المنتجات',
  'deliveryPage.minSearchLength': 'يرجى إدخال حرفين على الأقل',
  'deliveryPage.noOrdersFound': 'لم يتم العثور على طلبات',
  'deliveryPage.noReadyOrders': 'لا توجد طلبات جاهزة',
  'deliveryPage.ordersLoadError': 'تعذر تحميل الطلبات',
  'deliveryPage.payment': 'الدفع',
  'deliveryPage.paymentDialogTitle': 'اختر طريقة الدفع',
  'deliveryPage.pieces': 'القطع',
  'deliveryPage.quantity': 'الكمية',
  'deliveryPage.receiptDelivered': '✅ *تم التسليم*',
  'deliveryPage.search': 'بحث',
  'deliveryPage.searchEmptySubtitle': 'سيتم عرض الطلبات الجاهزة للتسليم',
  'deliveryPage.searchEmptyTitle': 'ابحث برقم الإيصال أو الاسم أو الهاتف',
  'deliveryPage.searchError': 'تعذر إجراء البحث',
  'deliveryPage.showItems': 'عرض المنتجات',
  'deliveryPage.statusCancelled': 'ملغى',
  'deliveryPage.statusDelivered': 'تم تسليمه',
  'deliveryPage.statusNotReady': 'تم العثور على الطلب لكنه غير جاهز للتسليم',
  'deliveryPage.statusPending': 'قيد الانتظار',
  'deliveryPage.title': 'التسليم',
  'deliveryPage.unknownProduct': 'منتج غير معروف',
  'deliveryPage.whatsappSending': '📱 جارٍ إرسال الإيصال عبر WhatsApp...',
  'driver.delivery': 'التسليم',
  'driver.pending': 'قيد المعالجة',
  'driver.pickup': 'استلام المنتجات',
  'driver.ready': 'جاهز',
  'driver.title': 'لوحة السائق',
  'driver.todayRevenue': 'إيرادات اليوم',
  'driver.totalPieces': 'إجمالي القطع',
  'error.customerNotCreated': 'تعذر إنشاء العميل',
  'error.customerNotDeleted': 'تعذر حذف العميل',
  'error.customerNotFound': 'لم يتم العثور على العميل',
  'error.customerNotUpdated': 'تعذر تحديث العميل',
  'error.customersNotLoaded': 'تعذر تحميل العملاء',
  'error.databaseError': 'خطأ في قاعدة البيانات',
  'error.expenseNotCreated': 'تعذر إنشاء المصروف',
  'error.expenseNotDeleted': 'تعذر حذف المصروف',
  'error.expensesNotLoaded': 'تعذر تحميل المصروفات',
  'error.forbidden': 'ليست لديك صلاحية لهذه العملية',
  'error.invalidRequest': 'طلب غير صالح',
  'error.orderNotCreated': 'تعذر إنشاء الطلب',
  'error.orderNotUpdated': 'تعذر تحديث الطلب',
  'error.ordersNotLoaded': 'تعذر تحميل الطلبات',
  'error.paymentFailed': 'فشلت عملية الدفع',
  'error.phoneAlreadyExists': 'رقم الهاتف هذا مسجل مسبقاً! يرجى استخدام رقم هاتف آخر.',
  'error.productNotCreated': 'تعذر إنشاء المنتج',
  'error.productNotUpdated': 'تعذر تحديث المنتج',
  'error.productsNotLoaded': 'تعذر تحميل المنتجات',
  'error.serverError': 'خطأ في الخادم',
  'error.tenantIdRequired': 'معلومات الجلسة مطلوبة',
  'error.tenantIdRequiredLogin': 'معلومات الجلسة مطلوبة. يرجى تسجيل الدخول.',
  'error.unauthorized': 'وصول غير مصرح به',
  'error.unknownError': 'حدث خطأ غير معروف',
  'error.userNotCreated': 'تعذر إنشاء المستخدم',
  'error.userNotUpdated': 'تعذر تحديث المستخدم',
  'error.usersNotLoaded': 'تعذر تحميل المستخدمين',
  'errorBoundary.forbidden': 'تم رفض الوصول',
  'errorBoundary.forbiddenDetails': 'ليست لديك صلاحيات كافية لتنفيذ هذه العملية.',
  'errorBoundary.goHome': 'العودة إلى الصفحة الرئيسية',
  'errorBoundary.pageNotFound': 'الصفحة غير موجودة',
  'errorBoundary.pageNotFoundDetails': 'الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.',
  'errorBoundary.persistentIssue': 'إذا استمرت المشكلة، يرجى التواصل مع فريق الدعم.',
  'errorBoundary.reload': 'إعادة تحميل الصفحة',
  'errorBoundary.serverError': 'خطأ في الخادم',
  'errorBoundary.serverErrorDetails': 'حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.',
  'errorBoundary.technicalDetails': 'التفاصيل التقنية',
  'errorBoundary.unauthorized': 'غير مصرح',
  'errorBoundary.unauthorizedDetails': 'ليس لديك تصريح لتنفيذ هذه العملية.',
  'errorBoundary.unknownError': 'خطأ غير معروف',
  'expenses.activeFilter': 'الفلتر النشط',
  'expenses.addNew': 'مصروف جديد',
  'expenses.amount': 'المبلغ',
  'expenses.amountField': 'المبلغ:',
  'expenses.amountLabel': 'المبلغ (₺) *',
  'expenses.applyFilter': 'تصفية',
  'expenses.cancel': 'إلغاء',
  'expenses.category': 'الفئة',
  'expenses.categoryField': 'الفئة:',
  'expenses.categoryLabel': 'الفئة *',
  'expenses.categoryPlaceholder': 'اختر فئة...',
  'expenses.clearFilter': 'مسح',
  'expenses.dateField': 'التاريخ:',
  'expenses.dateFilter': 'فلتر التاريخ',
  'expenses.deleteConfirm': 'هل أنت متأكد من حذف هذا المصروف؟',
  'expenses.deleteError': 'تعذر حذف المصروف',
  'expenses.deletePermission': 'ℹ️ صلاحية حذف المصروفات مقتصرة على دور المالك فقط.',
  'expenses.deleteTitle': 'حذف المصروف',
  'expenses.deleted': 'تم حذف المصروف',
  'expenses.deleting': 'جارٍ الحذف...',
  'expenses.description': 'الوصف',
  'expenses.descriptionField': 'الوصف:',
  'expenses.descriptionLabel': 'الوصف *',
  'expenses.endDate': 'تاريخ الانتهاء',
  'expenses.filterApplied': 'تم تطبيق فلتر التاريخ',
  'expenses.filterCleared': 'تم مسح الفلتر',
  'expenses.loadError': 'تعذر تحميل المصروفات',
  'expenses.newExpense': 'مصروف جديد',
  'expenses.noExpenses': 'لا توجد مصروفات مسجلة اليوم',
  'expenses.saveError': 'تعذر حفظ المصروف',
  'expenses.saved': 'تم حفظ المصروف',
  'expenses.selectBothDates': 'يرجى اختيار تاريخ البداية وتاريخ الانتهاء',
  'expenses.showDateFilter': 'اختر نطاق التاريخ',
  'expenses.startDate': 'تاريخ البداية',
  'expenses.title': 'إدخال المصروفات',
  'expenses.total': 'إجمالي المصروفات',
  'expenses.totalToday': 'إجمالي مصروفات اليوم',
  'expenses.yesDelete': 'نعم، احذف',
  'form.area': 'المساحة',
  'form.color': 'اللون',
  'form.damage': 'التلف',
  'form.notes': 'ملاحظات',
  'form.stain': 'البقعة',
  'invoices.subtitle': 'اعرض فواتير اشتراكك وقم بتنزيلها',
  'invoices.title': 'إدارة الفواتير',
  'loading': 'جارٍ التحميل...',
  'login': 'تسجيل الدخول',
  'login.demoCredentials': 'اسم المستخدم: demo، رمز PIN: 1234',
  'login.demoLoaded': 'تم إنشاء مستخدمين ومنتجات وعملاء وطلبات تجريبية!',
  'login.firstLoginChangePin': 'أول تسجيل دخول - يرجى تغيير رمز PIN',
  'login.invalidCredentials': 'اسم المستخدم أو رمز PIN غير صحيح',
  'login.legalText': 'بإنشائك حساباً فإنك توافق على شروط الخدمة وسياسة الخصوصية',
  'login.pin': 'رمز PIN',
  'login.pinDescription': 'من 4 إلى 6 أرقام',
  'login.pinRequired': 'رمز PIN مطلوب',
  'login.rememberMe': 'تذكرني',
  'login.signIn': 'تسجيل الدخول',
  'login.signingIn': 'جارٍ تسجيل الدخول...',
  'login.tenantIdNotRemembered': 'لم يتم حفظ معرّف الشركة',
  'login.tenantRequired': 'معرّف الشركة مطلوب',
  'login.tryForFree': 'جرّب مجاناً لمدة 15 يوماً، دون الحاجة إلى بطاقة ائتمان',
  'login.username': 'اسم المستخدم',
  'login.usernameRequired': 'اسم المستخدم مطلوب',
  'login.version': 'الإصدار',
  'logout': 'تسجيل الخروج',
  'menu.barber': 'حلاق / صالون تجميل',
  'menu.carWash': 'غسيل السيارات',
  'menu.referral': 'ادعُ صديقاً',
  'newPin': 'رمز PIN الجديد',
  'notifications': 'الإشعارات',
  'notifications.scheduleLater': 'إرسال لاحقاً',
  'notifications.selectDateTime': 'اختر التاريخ والوقت',
  'notifications.selectTemplate': 'اختر القالب',
  'notifications.sendError': 'تعذر الإرسال',
  'notifications.sms': 'SMS',
  'notifications.subtitle': 'عدّل إعدادات إشعارات SMS وWhatsApp',
  'notifications.success': 'تم إرسال الإشعار بنجاح',
  'notifications.title': 'رسائل إعلامية SMS/WhatsApp',
  'notifications.whatsapp': 'WhatsApp',
  'order.addressIcon': '📍 العنوان',
  'order.addressRequiredForDelivery': 'معلومات العنوان مطلوبة للتسليم إلى العنوان',
  'order.balanced': 'متوازن',
  'order.debt': 'دين',
  'order.discountOptional': 'الخصم (اختياري)',
  'order.discountPercent': 'الخصم (%{percent})',
  'order.discountRate': 'الخصم',
  'order.discountSummary': 'ملخص الخصم',
  'order.enterDiscountRate': 'أدخل نسبة الخصم (0-100):',
  'order.homeDeliveryIcon': '🏠 التسليم إلى العنوان',
  'order.homeDeliveryShort': 'التسليم إلى العنوان',
  'order.newPrice': 'السعر الجديد',
  'order.notesOptional': 'ملاحظات (اختياري)',
  'order.notesPlaceholder': 'معلومات إضافية، طلبات خاصة...',
  'order.priceAndDiscountEdit': 'تعديل السعر والخصم',
  'order.quickDiscount': 'أزرار الخصم السريع',
  'order.receivable': 'مستحق',
  'order.selectPaymentMethod': 'اختر طريقة الدفع',
  'order.totalDebt': 'إجمالي الدين',
  'order.totalPayments': 'إجمالي المدفوعات',
  'order.totalWithQuantity': 'الإجمالي ({count} قطعة)',
  'orderCreate.addCustomer': 'إضافة عميل',
  'orderCreate.addressRequired': 'العنوان مطلوب!',
  'orderCreate.allCategories': 'الكل',
  'orderCreate.balance': 'الرصيد',
  'orderCreate.cart': 'السلة',
  'orderCreate.change': 'تغيير',
  'orderCreate.clickToSelect': 'انقر للاختيار',
  'orderCreate.continue': 'متابعة',
  'orderCreate.credit': 'دائن',
  'orderCreate.customer': 'العميل',
  'orderCreate.customerAddress': 'العنوان',
  'orderCreate.customerEmail': 'البريد الإلكتروني',
  'orderCreate.customerName': 'الاسم واللقب',
  'orderCreate.customerPhone': 'الهاتف',
  'orderCreate.debt': 'دين',
  'orderCreate.deliveryDate': 'تاريخ التسليم',
  'orderCreate.details': 'التفاصيل',
  'orderCreate.discount': 'الخصم',
  'orderCreate.discountLabel': 'الخصم (%)',
  'orderCreate.grandTotal': 'الإجمالي الكلي',
  'orderCreate.homeDelivery': 'التوصيل إلى المنزل',
  'orderCreate.homeDeliveryAddress': 'العنوان',
  'orderCreate.itemDetails': 'تفاصيل القطعة',
  'orderCreate.newCustomer': 'عميل جديد',
  'orderCreate.payment': 'الدفع',
  'orderCreate.pickupFromAddress': 'سيستلم السائق من العنوان',
  'orderCreate.plannedDelivery': 'التسليم المخطط',
  'orderCreate.save': 'حفظ',
  'orderCreate.searchCustomer': 'ابحث بالاسم أو الهاتف أو العنوان... (مثال: john+5551234567)',
  'orderCreate.select': 'اختيار',
  'orderCreate.selectCustomer': 'اختر العميل',
  'orderCreate.selectCustomerPlaceholder': 'اختر عميلاً',
  'orderCreate.serviceType': 'نوع الخدمة',
  'orderCreate.subtotal': 'المجموع الفرعي',
  'orderCreate.tailoringOperations': 'عمليات الخياطة',
  'orderCreate.tailoringTitle': 'عمليات الخياطة',
  'orderCreate.totalPieces': 'إجمالي القطع',
  'payment.account': 'حساب جارٍ',
  'payment.addPayment': 'إضافة دفعة',
  'payment.amount': 'مبلغ الدفعة',
  'payment.amountToPay': 'المبلغ المستحق الدفع',
  'payment.bankTransfer': 'تحويل بنكي',
  'payment.card': 'بطاقة ائتمان',
  'payment.cash': 'نقداً',
  'payment.complete': 'إتمام الدفع',
  'payment.completed': 'مكتمل',
  'payment.confirm': 'تأكيد الدفع',
  'payment.creditCard': 'بطاقة ائتمان',
  'payment.enterAmount': 'أدخل مبلغ الدفع',
  'payment.failed': 'فشلت عملية الدفع',
  'payment.madePayments': 'المدفوعات المسددة',
  'payment.mealCard': 'بطاقة وجبات',
  'payment.method': 'طريقة الدفع',
  'payment.onDelivery': 'عند التسليم',
  'payment.paid': 'المدفوع',
  'payment.partial': 'دفع جزئي',
  'payment.pending': 'قيد الانتظار',
  'payment.posConfirm': 'بعد استلام تأكيد الدفع من جهاز نقاط البيع، اضغط على زر "تأكيد".',
  'payment.posInstructions': 'يرجى تحصيل الدفعة من العميل عبر جهاز نقاط البيع.',
  'payment.posPayment': 'الدفع ببطاقة الائتمان (جهاز نقاط البيع)',
  'payment.remaining': 'المتبقي',
  'payment.selectMethod': 'اختر طريقة الدفع',
  'payment.splitPayment': 'دفع مجزأ',
  'payment.status': 'حالة الدفع',
  'payment.success': 'تمت عملية الدفع بنجاح',
  'permissions.about': 'حول إدارة الصلاحيات',
  'permissions.activePermissions': 'الصلاحيات النشطة:',
  'permissions.cashier': 'أمين الصندوق',
  'permissions.cashierInfo': '<strong>أمين الصندوق:</strong> دور مستخدم بصلاحيات محدودة للعمليات اليومية.',
  'permissions.cashierRole': 'مستخدم بصلاحيات محدودة',
  'permissions.deselectAllCashier': 'إلغاء تحديد الكل لأمين الصندوق',
  'permissions.deselectAllPatron': 'إلغاء تحديد الكل للمالك',
  'permissions.infoText1': 'دور المدير الرئيسي الذي يملك جميع صلاحيات النظام.',
  'permissions.infoText2': 'دور مستخدم بصلاحيات محدودة للعمليات اليومية.',
  'permissions.infoText3': 'لن تسري التغييرات حتى يتم حفظها.',
  'permissions.infoText4': 'يمكن تخصيص الصلاحيات لكل دور.',
  'permissions.infoTitle': 'حول إدارة الصلاحيات',
  'permissions.patron': 'المالك',
  'permissions.patronInfo': '<strong>المالك:</strong> دور المدير الرئيسي الذي يملك جميع صلاحيات النظام.',
  'permissions.patronRole': 'مدير بصلاحيات كاملة',
  'permissions.permissionList': 'قائمة الصلاحيات',
  'permissions.saveError': 'تعذر حفظ الصلاحيات',
  'permissions.saveSuccess': 'تم حفظ الصلاحيات',
  'permissions.saving': 'جارٍ الحفظ...',
  'permissions.selectAllCashier': 'تحديد الكل لأمين الصندوق',
  'permissions.selectAllPatron': 'تحديد الكل للمالك',
  'permissions.subtitle': 'حدد صلاحيات دوري المالك وأمين الصندوق',
  'permissions.title': 'إدارة الصلاحيات',
  'pinDigits': '6 أرقام',
  'pricing.action': 'الإجراء',
  'pricing.dryCleaning': 'تنظيف جاف',
  'pricing.ironing': 'كيّ',
  'pricing.dyeing': 'صباغة',
  'pricing.loadError': 'تعذر تحميل المنتجات',
  'pricing.noProducts': 'لم يتم العثور على منتجات',
  'pricing.pricesSaveError': 'تعذر حفظ الأسعار',
  'pricing.pricesSaved': 'تم حفظ الأسعار',
  'pricing.product': 'المنتج',
  'pricing.save': 'حفظ',
  'pricing.saving': 'جارٍ الحفظ',
  'pricing.search': 'البحث عن منتج...',
  'pricing.shoeShine': 'تلميع الأحذية',
  'pricing.tailoring': 'إصلاح الخياطة',
  'pricing.title': 'تحديد الأسعار',
  'pricing.washing': 'غسيل',
  'products.addError': 'تعذرت إضافة المنتج',
  'products.allCategories': 'جميع الفئات',
  'products.delete': 'حذف',
  'products.deleteConfirm': 'هل أنت متأكد من حذف هذا المنتج؟',
  'products.deleteError': 'تعذر حذف المنتج',
  'products.deleting': 'جارٍ الحذف...',
  'products.editProduct': 'تعديل المنتج',
  'products.loadError': 'تعذر تحميل المنتجات',
  'products.newProduct': 'منتج جديد',
  'products.pieceCount': 'عدد القطع',
  'products.productActive': 'نشط',
  'products.productAdded': 'تمت إضافة المنتج',
  'products.productCategory': 'الفئة',
  'products.productDeleted': 'تم حذف المنتج',
  'products.productInActive': 'غير نشط',
  'products.productName': 'اسم المنتج',
  'products.productPrice': 'السعر',
  'products.productUpdated': 'تم تحديث المنتج',
  'products.save': 'حفظ',
  'products.saveError': 'تعذر الحفظ',
  'products.saved': 'تم الحفظ',
  'products.saving': 'جارٍ الحفظ...',
  'products.searchProduct': 'البحث عن منتج...',
  'products.updateError': 'تعذر تحديث المنتج',
  'products.updatePrice': 'تحديث السعر',
  'products.updatePrices': 'تحديث الأسعار',
  'profile.changePassword': 'تغيير كلمة المرور',
  'profile.confirmPassword': 'تأكيد كلمة المرور',
  'profile.currentPassword': 'كلمة المرور الحالية',
  'profile.email': 'البريد الإلكتروني',
  'profile.name': 'الاسم',
  'profile.newPassword': 'كلمة المرور الجديدة',
  'profile.passwordChangeError': 'تعذر تغيير كلمة المرور',
  'profile.passwordChanged': 'تم تغيير كلمة المرور بنجاح',
  'profile.passwordMismatch': 'كلمتا المرور غير متطابقتين',
  'profile.phone': 'الهاتف',
  'profile.role': 'الدور',
  'profile.save': 'حفظ',
  'profile.saveError': 'تعذر حفظ الملف الشخصي',
  'profile.saved': 'تم الحفظ',
  'profile.saving': 'جارٍ الحفظ...',
  'profile.subscriptionBilling': 'الاشتراك والفوترة',
  'profile.title': 'الملف الشخصي',
  'receipt.andLabel': 'والملصق',
  'receipt.back': 'رجوع',
  'receipt.customerReceipt': 'إيصال العميل',
  'receipt.damage': 'التلف',
  'receipt.labelConfirmDesc': 'تم إنشاء الإيصال. هل تريد إرسال الملصق إلى طابعة الملصقات؟',
  'receipt.labelConfirmTitle': 'طباعة الملصق؟',
  'receipt.labelNo': 'لا',
  'receipt.labelPrinting': 'جارٍ طباعة الملصق {current}/{total}...',
  'receipt.labelYes': 'نعم، اطبع',
  'receipt.loadError': 'تعذر تحميل البيانات',
  'receipt.newOrder': 'طلب جديد',
  'receipt.noResults': 'لا توجد نتائج',
  'receipt.notFound': 'لم يتم العثور على الإيصال',
  'receipt.plannedDelivery': 'التسليم المخطط',
  'receipt.price': 'السعر',
  'receipt.print': 'طباعة الإيصال',
  'receipt.printButton': 'طباعة الإيصال',
  'receipt.product': 'المنتج',
  'receipt.products': 'منتجات',
  'receipt.quantity': 'الكمية',
  'receipt.resultsCount': 'تم العثور على {count} نتيجة',
  'receipt.search': 'البحث عن الإيصالات وإعادة طباعتها',
  'receipt.searchEmpty': 'أدخل رقم الإيصال أو اسم العميل للبحث',
  'receipt.searchPlaceholder': 'ابحث برقم الإيصال أو اسم العميل أو الهاتف...',
  'receipt.stain': 'البقعة',
  'receipt.tax': 'الضريبة (KDV)',
  'receipt.taxPercent': 'الضريبة (20%)',
  'receipt.time': 'الوقت',
  'receipt.total': 'الإجمالي',
  'receipt.totalPieces': 'إجمالي القطع',
  'receipt.whatsappOpening': 'جارٍ فتح WhatsApp...',
  'receipt.whatsappSend': 'إرسال عبر WhatsApp',
  'reports.dateRange': 'نطاق التاريخ',
  'reportsList.created': 'تاريخ الإنشاء',
  'reportsList.deliveredThisPeriod': '📦 مسجلة سابقاً، مُسلَّمة في هذه الفترة ({count} إيصال)',
  'reportsList.registeredThisPeriod': '📝 المسجلة في هذه الفترة ({count} إيصال)',
  'save': 'حفظ',
  'service.dryCleaningFull': 'تنظيف جاف',
  'settings.addDemoProducts': 'إضافة المنتجات التجريبية',
  'settings.adding': 'جارٍ الإضافة...',
  'settings.afrika': 'أفريقيا',
  'settings.clickConnectButton': 'انقر على زر "اتصال"',
  'settings.companyInfo': 'معلومات الشركة',
  'settings.companyLogo': 'شعار الشركة',
  'settings.connectDeviceInfo': 'قم بتوصيل جهاز إظهار رقم المتصل (Caller ID) عبر USB بجهاز الكمبيوتر',
  'settings.currencyFormat': 'تنسيق العملة',
  'settings.currencyPositionPreview': 'الرمز {position}: {example}',
  'settings.currencyPositionPreviewLeft': 'الرمز على اليسار',
  'settings.currencyPositionPreviewRight': 'الرمز على اليمين',
  'settings.cut': 'قص',
  'settings.defaultCategory': 'الفئة الافتراضية',
  'settings.defaultCategoryDesc': 'الفئة التي ستُحدد تلقائياً عند فتح شاشة تسجيل المنتجات',
  'settings.defaultServiceType': 'نوع الخدمة الافتراضي',
  'settings.defaultServiceTypeDesc': 'نوع الخدمة الذي سيُحدد تلقائياً عند فتح شاشة تسجيل المنتجات',
  'settings.delete': 'حذف',
  'settings.deleteButton': 'حذف البيانات التجريبية',
  'settings.deleteDemoDataDesc': 'ستؤدي هذه العملية إلى حذف جميع العملاء والطلبات وسجلات الدفع التجريبية نهائياً.',
  'settings.deliveryDays': 'مدة التسليم (بالأيام)',
  'settings.demoProducts': 'المنتجات التجريبية',
  'settings.demoProductsDescription': 'يضيف منتجات تجريبية مع أسعارها المحددة',
  'settings.email': 'البريد الإلكتروني',
  'settings.europeanLanguages': 'اللغات الأوروبية',
  'settings.facebook': 'Facebook',
  'settings.feedForward': 'تغذية الورق للأمام',
  'settings.footerPlaceholder': 'رسالة التذييل',
  'settings.formerSovietTurkic': 'دول الاتحاد السوفيتي السابق والدول التركية',
  'settings.genericEscPos': 'ESC/POS عام',
  'settings.howToConnect': '💡 كيفية الاتصال؟',
  'settings.instagram': 'Instagram',
  'settings.labelPrinter': 'طابعة الملصقات',
  'settings.lastCall': 'آخر مكالمة',
  'settings.logoDescription': 'سيظهر الشعار على الإيصالات وفي أعلى يسار البرنامج. الحجم الموصى به: 300x120 بكسل على الأقل، بصيغة PNG أو JPG عالية الدقة',
  'settings.majorCurrencies': 'العملات الرئيسية',
  'settings.menu': 'قائمة الإعدادات',
  'settings.middleEast': 'الشرق الأوسط',
  'settings.middleEastAfricanLanguages': 'لغات الشرق الأوسط وأفريقيا',
  'settings.middleEastGulf': 'الشرق الأوسط والخليج',
  'settings.noLogo': 'لا يوجد شعار',
  'settings.oceania': 'أوقيانوسيا',
  'settings.openDrawer': 'فتح درج النقود',
  'settings.orderCreated': 'تم إنشاء الطلب',
  'settings.orderDelivered': 'تم تسليم الطلب',
  'settings.orderReady': 'الطلب جاهز',
  'settings.otherLanguages': 'لغات أخرى',
  'settings.paperWidth': 'عرض الورق',
  'settings.phonePlaceholder': 'مثال: 0212 123 45 67',
  'settings.popularLanguages': 'اللغات الشائعة',
  'settings.previewItem1': 'المنتج 1',
  'settings.previewItem2': 'المنتج 2',
  'settings.previewTotal': 'الإجمالي',
  'settings.receiptFooterText': 'نص تذييل الإيصال',
  'settings.receiptVisibleOnReceipt': 'يظهر على الإيصال',
  'settings.reverse': 'عكسي',
  'settings.reverseTest': '--- اختبار الطباعة العكسية ---',
  'settings.selectDevice': 'اختر جهاز CID من القائمة (عادةً "USB Serial Device")',
  'settings.smsTemplates': 'قوالب رسائل SMS',
  'settings.successful': 'بنجاح!',
  'settings.testPrintHeader': '=== اختبار الطابعة ===',
  'settings.testPrinted': 'تمت طباعة الاختبار!',
  'settings.webSerialNotSupported': 'متصفحك لا يدعم Web Serial API. نوصي باستخدام متصفحات مبنية على Chromium (Chrome وEdge وBrave).',
  'settings.webSerialSupported': 'Web Serial API مدعوم',
  'settings.whatsappTemplates': 'قوالب رسائل WhatsApp',
  'settings.workOnSunday': 'العمل أيام الأحد',
  'settings.yesDelete': 'نعم، احذف',
  'smsSettingsRequired': 'قم بضبط إعدادات SMS أعلاه وحفظها قبل إرسال رسالة SMS تجريبية',
  'stain.blood': 'دم',
  'stain.fruit': 'فاكهة',
  'stain.ink': 'حبر',
  'stain.mud': 'طين',
  'stain.multiple': 'حالة البقع (يمكن اختيار أكثر من خيار)',
  'stain.none': 'لا يوجد',
  'stain.oil': 'زيت',
  'stain.other': 'بقعة أخرى...',
  'stain.paint': 'طلاء',
  'stain.pembe': 'وردي',
  'stain.rust': 'صدأ',
  'stain.salt': 'ملح',
  'stain.status': 'حالة البقع',
  'stain.teaCoffee': 'شاي/قهوة',
  'subscription.autoRenewActive': '✅ التجديد التلقائي مفعّل - الدفعة التالية:',
  'subscription.autoRenewBadge': '🔄 اشتراك قابل للتجديد التلقائي',
  'subscription.autoRenewInfo': '🔄 يتجدد اشتراكك تلقائياً. ستتلقى إشعاراً عبر البريد الإلكتروني قبل التجديد.',
  'subscription.billingAutoSave': '💾 يتم حفظ معلوماتك تلقائياً وتعبئتها في عملية الدفع القادمة',
  'subscription.billingDesc': 'أدخل معلومات الفوترة وانتقل إلى خطوة الدفع',
  'subscription.billingInfoSaved': '✅ تم حفظ معلومات الفوترة',
  'subscription.billingLangLabel': 'لغة الفاتورة',
  'subscription.branchCashManagement': 'إدارة صندوق خاصة بكل فرع',
  'subscription.branchesIncluded': 'يشمل حتى فرعين',
  'subscription.cancelAnytime': 'ℹ️ يمكنك إلغاء الاشتراك في أي وقت.',
  'subscription.cancelSubBtn': '❌ إلغاء الاشتراك',
  'subscription.cardAtPayment': '💳 ستتم عملية الدفع باستخدام بيانات بطاقتك في صفحة الدفع.',
  'subscription.cardInfoTitle': 'سيتم إدخال بيانات البطاقة في صفحة الدفع',
  'subscription.changePlan': '💳 تغيير',
  'subscription.changePlanIntl': '🏓 تغيير',
  'subscription.comparePlans': 'قارن بين الخطط',
  'subscription.crossBranchDelivery': 'التسليم بين الفروع',
  'subscription.customersLabel': 'العملاء',
  'subscription.emailNotifBadge': '💳 إشعار بالبريد الإلكتروني قبل التجديد',
  'subscription.enterBillingInfo': '📄 يرجى تعبئة معلومات الفوترة',
  'subscription.enterpriseOnlyDesc': 'إدارة الفروع متاحة فقط في خطة Enterprise. انتقل إلى Enterprise لإدارة عدة فروع، وإدارة صندوق خاصة بكل فرع، والتسليم بين الفروع.',
  'subscription.enterpriseOnlyTitle': 'خطة Enterprise مطلوبة',
  'subscription.expiringDays': 'ستنتهي مدة اشتراكك بعد {days} يوم. يرجى التجديد لضمان استمرار الخدمة دون انقطاع.',
  'subscription.expiryLabel': 'تاريخ الانتهاء:',
  'subscription.extendBtn': 'تمديد الاشتراك',
  'subscription.extendSubBtn': '💳 تمديد الاشتراك',
  'subscription.extendedBy1m': 'سيتم التمديد لمدة شهر',
  'subscription.extendedBy1y': 'سيتم التمديد لمدة سنة',
  'subscription.faq1a': 'عند تغيير الخطة، تحصل فوراً على الميزات الجديدة. وتُضاف المدة التي اشتريتها (شهرية أو سنوية) إلى مدة اشتراكك الحالية.',
  'subscription.faq1q': 'ماذا يحدث عند تغيير الخطة؟',
  'subscription.faq2a': 'إذا ألغيت اشتراكك، ستستمر في الحصول على الخدمة حتى نهاية الفترة الحالية. وتُحفظ بياناتك لمدة 15 يوماً.',
  'subscription.faq2q': 'ماذا يحدث إذا ألغيت الاشتراك؟',
  'subscription.faq3a': 'نقبل الدفع ببطاقات الائتمان والبطاقات البنكية فقط. لا يمكن الدفع عبر التحويل البنكي.',
  'subscription.faq3q': 'ما طرق الدفع التي تقبلونها؟',
  'subscription.faq4a': 'يمكنك استخدام جميع الميزات مجاناً لمدة 15 يوماً من تاريخ فتح الحساب. وعند انتهاء الفترة التجريبية يجب عليك شراء اشتراك.',
  'subscription.faq4q': 'كيف تعمل الفترة التجريبية لمدة 15 يوماً؟',
  'subscription.faqTitle': 'الأسئلة الشائعة',
  'subscription.manageBilling': 'إدارة الفواتير',
  'subscription.odealPOS': 'تكامل مع Ödeal POS (اختياري)',
  'subscription.paymentRequiredBadge': '💳 الدفع مطلوب للتجديد',
  'subscription.planWord': 'خطة',
  'subscription.purchasePlanTitle': 'شراء خطة {name}',
  'subscription.receiptsLabel': 'الإيصالات',
  'subscription.referralDesc': 'عندما يسجّل صديق دعوته ويصبح عضوًا، تحصل على شهر إضافي! إرسال الدعوة وحده لا يكفي.',
  'subscription.referralShare': 'مشاركة رابط الدعوة',
  'subscription.referralTitle': 'أوصِ أصدقاءك',
  'subscription.removeCoupon': 'إزالة',
  'subscription.renewsInDays': 'سيتجدد اشتراكك الحالي خلال {days} يوم',
  'subscription.saveInfoBtn': '💾 حفظ المعلومات',
  'subscription.saveInfoHint': 'ستُعبأ تلقائياً في عملية الدفع القادمة',
  'subscription.savedBillingInfo': '📄 معلومات الفوترة المحفوظة',
  'subscription.selectBtn': 'اختيار',
  'subscription.subCancelledBadge': '⚠️ تم إلغاء الاشتراك',
  'subscription.subInfoTitle': '📋 معلومات الاشتراك',
  'subscription.subIsMonthly': '✅ هذه عملية اشتراك شهري.',
  'subscription.subIsYearly': '✅ هذه عملية اشتراك سنوي.',
  'subscription.subtitle': 'أدر خطتك واضبط إعدادات الفوترة',
  'subscription.supportTimeLabel': 'مدة الاستجابة لتذاكر الدعم',
  'subscription.switchPlan': '💳 الانتقال إلى الباقة',
  'subscription.switchPlanIntl': '🏓 الانتقال إلى الباقة',
  'subscription.taxOffice': 'مكتب الضرائب',
  'subscription.totalAmountLabel': 'المبلغ الإجمالي',
  'subscription.trial15d': 'فترة تجريبية لمدة 15 يوماً',
  'subscription.unlimitedUsers': 'عدد غير محدود من المستخدمين',
  'subscription.upgradeBtn': 'ترقية',
  'subscription.upgradeToEnterprise': 'الانتقال إلى Enterprise',
  'subscription.usageTitle': 'الاستخدام والحدود لهذا الشهر',
  'subscription.usersLabel': 'المستخدمون',
  'subscription.vatNote': '+ ضريبة القيمة المضافة (20%)',
  'subscription.warning': 'تنبيه الاشتراك',
  'subscription.yearlyFreeBtn': '🎉 سنوي (شهران مجاناً!)',
  'subscription.yearlyFreeNote': '🎉 شهران مجاناً مع الدفع السنوي!',
  'subscription.yearlySavings': '💡 وفّر 17% مع الدفع السنوي',
  'tailoring.addCustom': 'إضافة عملية مخصصة',
  'tailoring.astarDegisimi': 'تغيير البطانة',
  'tailoring.belAyarı': 'تعديل الخصر',
  'tailoring.cancel': 'إلغاء',
  'tailoring.cepDikimi': 'خياطة الجيب',
  'tailoring.dugmeDikme': 'تركيب الأزرار',
  'tailoring.fermuarDegisimi': 'تغيير السحّاب',
  'tailoring.icon': 'الأيقونة',
  'tailoring.kolBoyu': 'طول الكم',
  'tailoring.omuzAyarı': 'تعديل الكتف',
  'tailoring.operationName': 'اسم العملية',
  'tailoring.pacaBoyu': 'خياطة فتحة الإبط',
  'tailoring.price': 'السعر',
  'tailoring.save': 'حفظ',
  'tailoring.sokukDikimi': 'خياطة الفتق',
  'tailoring.yama': 'رقعة',
  'toast.carpetAddedToCart': 'تمت إضافة السجادة إلى السلة',
  'toast.carpetsAddedToCart': 'تمت إضافة السجاد إلى السلة',
  'toast.connectionError': 'تعذر حفظ الاتصال',
  'toast.connectionStatusError': 'تعذر تحميل حالة الاتصال',
  'toast.customerAdded': 'تمت إضافة العميل',
  'toast.customerError': 'تعذرت إضافة العميل',
  'toast.demoDataDeleteError': 'تعذر حذف البيانات التجريبية',
  'toast.disconnectError': 'تعذر قطع الاتصال',
  'toast.enterValidValue': 'أدخل قيمة صالحة',
  'toast.logoRemoved': 'تمت إزالة الشعار. لا تنسَ الحفظ!',
  'toast.logoTypeError': 'يمكن تحميل ملفات الصور فقط',
  'toast.logoUploaded': 'تم تحميل الشعار. لا تنسَ الحفظ!',
  'toast.orderCreated': 'تم إنشاء الطلب',
  'toast.orderError': 'تعذر إنشاء الطلب',
  'toast.orderSetToReady': 'تم تحديد الطلب كجاهز',
  'toast.orderStatusUpdateError': 'تعذر تحديث حالة الطلب',
  'toast.orderStatusUpdated': 'تم تحديث حالة الطلب',
  'toast.pinChangeError': 'تعذر تغيير رمز PIN',
  'toast.pinChanged': 'تم تغيير رمز PIN',
  'toast.productError': 'تعذرت إضافة المنتج',
  'toast.qrError': 'تعذر إنشاء رمز QR',
  'toast.qrGenerated': 'تم إنشاء رمز QR. يرجى مسحه باستخدام تطبيق WhatsApp Business.',
  'toast.selectPaymentMethodFirst': 'اختر طريقة الدفع أولاً',
  'toast.settingsError': 'تعذر حفظ الإعدادات',
  'toast.settingsLoadError': 'تعذر تحميل الإعدادات',
  'toast.settingsSaved': 'تم حفظ الإعدادات',
  'toast.statsError': 'تعذر تحميل الإحصائيات',
  'toast.statusUpdateError': 'تعذر تحديث الحالة',
  'toast.userAddError': 'تعذرت إضافة المستخدم',
  'toast.userAdded': 'تمت إضافة المستخدم',
  'toast.userDeleteError': 'تعذر حذف المستخدم',
  'toast.userDeleted': 'تم حذف المستخدم بنجاح',
  'toast.userUpdateError': 'تعذر تحديث المستخدم',
  'toast.userUpdated': 'تم تحديث المستخدم',
  'toast.usersLoadError': 'تعذر تحميل المستخدمين',
  'toast.whatsappConnected': 'تم ربط WhatsApp Business بنجاح!',
  'toast.whatsappDisconnected': 'تم قطع اتصال WhatsApp Business',
  'update': 'تحديث',
  'users.deleteError': 'تعذر حذف المستخدم',
  'users.loadError': 'تعذر تحميل المستخدمين',
  'users.userDeleteError': 'تعذر حذف المستخدم',
  'users.userDeleted': 'تم حذف المستخدم بنجاح',
  'whatsapp.connectWithQR': 'الاتصال عبر رمز QR',
  'whatsapp.connectionStatus': 'حالة الاتصال',
  'whatsapp.deliveryReminder': '{customerName}، لم تستلم طلبك رقم {orderNumber} منذ {daysAgo} يوم. يرجى استلامه في أقرب وقت ممكن.',
  'whatsapp.generateQR': 'إنشاء رمز QR',
  'whatsapp.importantInfo': 'معلومات مهمة',
  'whatsapp.info1': '1. امسح رمز QR باستخدام تطبيق WhatsApp على هاتفك',
  'whatsapp.info2': '2. بعد إنشاء الاتصال يمكنك إرسال رسائل تلقائية',
  'whatsapp.info3': '3. لقطع الاتصال، سجّل الخروج من إعدادات WhatsApp',
  'whatsapp.info4': '4. يتجدد رمز QR تلقائياً بعد 60 ثانية',
  'whatsapp.messageHistory': 'سجل الرسائل',
  'whatsapp.notConnectedMessage': 'لم يتم ربط حساب WhatsApp الخاص بك بعد',
  'whatsapp.receiptMessage': 'عزيزنا {customerName}، طلبك رقم {orderNumber} جاهز وبانتظار الاستلام.',
  'whatsapp.subtitle': 'أدر اتصال WhatsApp Business API الخاص بك',
  'whatsapp.thankYou': 'شكراً لك!',
  'zReport.account': 'حساب جارٍ (Caripay)',
  'zReport.accountCollections': 'تحصيلات الحسابات الجارية',
  'zReport.bankTransfer': 'تحويل بنكي',
  'zReport.cancelledOrders': 'الطلبات الملغاة',
  'zReport.cancelledReceipts': 'الإيصالات الملغاة',
  'zReport.cariCollection': 'تحصيل الحساب الجاري',
  'zReport.cash': 'نقداً',
  'zReport.cashCalculation': '(النقد الافتتاحي + نقد اليوم - المصروفات)',
  'zReport.cashRegister': 'الصندوق',
  'zReport.cashToDeliver': 'النقد الواجب تسليمه',
  'zReport.collectedItems': 'المحصَّلة',
  'zReport.collectionDetails': 'تفاصيل التحصيل',
  'zReport.creditCard': 'بطاقة ائتمان',
  'zReport.dailyCashIncome': 'الدخل النقدي اليومي',
  'zReport.dateRange': 'نطاق التاريخ',
  'zReport.deliveryCard': 'بطاقة ائتمان محصلة عند التسليم',
  'zReport.deliveryCash': 'نقد محصل عند التسليم',
  'zReport.discountNotReflected': 'تُحسب المبالغ على أساس الأسعار الصافية بعد تطبيق الخصم.',
  'zReport.excelDownloaded': 'تم تنزيل ملف Excel',
  'zReport.excelError': 'خطأ في تنزيل ملف Excel',
  'zReport.expenses': 'المصروفات',
  'zReport.incoming': 'الوارد',
  'zReport.infoNote': 'لأغراض إعلامية فقط',
  'zReport.loadError': 'تعذر تحميل تقرير Z',
  'zReport.loading': 'جارٍ التحميل...',
  'zReport.mealCard': 'بطاقة وجبات',
  'zReport.noCancelled': 'لا توجد إيصالات ملغاة',
  'zReport.noExpenses': 'لا توجد مصروفات',
  'zReport.onDelivery': 'الدفع عند التسليم',
  'zReport.orderCollections': 'تحصيلات الطلبات',
  'zReport.orderPaidAtDelivery': 'طلبات مدفوعة عند التسليم',
  'zReport.orderPaidAtRegister': 'طلبات مدفوعة عند التسجيل',
  'zReport.outgoing': 'الصادر',
  'zReport.paidAtDelivery': 'مدفوع عند التسليم',
  'zReport.paidAtRegister': 'مدفوع عند التسجيل',
  'zReport.paymentDetails': 'تفاصيل التحصيل',
  'zReport.paymentMethods': 'طرق الدفع',
  'zReport.reason': 'السبب',
  'zReport.registrationAndDelivery': 'التسجيل + التسليم',
  'zReport.singleDay': 'يوم واحد',
  'zReport.startingCash': 'النقد الافتتاحي',
  'zReport.totalCancelled': '{count} إيصال ملغى',
  'zReport.totalCollection': 'إجمالي التحصيل',
  'zReport.totalExpenses': 'إجمالي المصروفات',
  'zReport.totalRegistered': 'إجمالي المسجل',
  'zReport.totalSales': 'إجمالي المبيعات',
  'toast.logoSizeError': 'يجب أن يكون حجم ملف الشعار أقل من 500 كيلوبايت',
  'zReport.todayOrders': 'طلبات اليوم',
};
